import { ref as S, watch as N, customRef as gr, getCurrentScope as _n, onScopeDispose as Cn, unref as k, computed as T, defineComponent as F, inject as vt, useAttrs as ye, openBlock as v, createElementBlock as y, mergeProps as Te, renderSlot as _, provide as mt, normalizeClass as x, withDirectives as Je, Fragment as le, renderList as Z, toDisplayString as B, vModelSelect as hr, createCommentVNode as R, createBlock as q, withCtx as O, createTextVNode as V, createVNode as j, vModelDynamic as vr, createElementVNode as D, vModelText as mr, withModifiers as lt, pushScopeId as br, popScopeId as yr, createSlots as wr, useSlots as Sn, TransitionGroup as kr, shallowRef as xr, shallowReadonly as ze, onMounted as $n, resolveDynamicComponent as _r, normalizeStyle as qt, vShow as Cr, withKeys as it, vModelRadio as Sr, readonly as $r, toRef as Mr, reactive as Ar, nextTick as Ut } from "vue";
function Mn(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Mn(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Or() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Mn(e)) && (r && (r += " "), r += t);
  return r;
}
const Xt = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Qt = Or, ee = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Qt(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = a == null ? void 0 : a[c];
    if (u === null)
      return null;
    const f = Xt(u) || Xt(d);
    return o[c][f];
  }), i = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...p } = u;
    return Object.entries(p).every((h) => {
      let [g, b] = h;
      return Array.isArray(b) ? b.includes({
        ...a,
        ...i
      }[g]) : {
        ...a,
        ...i
      }[g] === b;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return Qt(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Dr(e, t) {
  let n, r, o;
  const a = S(!0), s = () => {
    a.value = !0, o();
  };
  N(e, s, { flush: "sync" });
  const i = typeof t == "function" ? t : t.get, l = typeof t == "function" ? void 0 : t.set, c = gr((u, d) => (r = u, o = d, {
    get() {
      return a.value && (n = i(), a.value = !1), r(), n;
    },
    set(f) {
      l == null || l(f);
    }
  }));
  return Object.isExtensible(c) && (c.trigger = s), c;
}
function Tr(e) {
  return _n() ? (Cn(e), !0) : !1;
}
function ct(e) {
  return typeof e == "function" ? e() : k(e);
}
const An = typeof window < "u" && typeof document < "u", Er = Object.prototype.toString, zr = (e) => Er.call(e) === "[object Object]", Ue = () => {
}, Fr = /* @__PURE__ */ Rr();
function Rr() {
  var e;
  return An && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function On(e, t) {
  function n(...r) {
    return new Promise((o, a) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(o).catch(a);
    });
  }
  return n;
}
const Ir = (e) => e();
function Pr(e, t = {}) {
  let n, r, o = Ue;
  const a = (i) => {
    clearTimeout(i), o(), o = Ue;
  };
  return (i) => {
    const l = ct(e), c = ct(t.maxWait);
    return n && a(n), l <= 0 || c !== void 0 && c <= 0 ? (r && (a(r), r = null), Promise.resolve(i())) : new Promise((u, d) => {
      o = t.rejectOnCancel ? d : u, c && !r && (r = setTimeout(() => {
        n && a(n), r = null, u(i());
      }, c)), n = setTimeout(() => {
        r && a(r), r = null, u(i());
      }, l);
    });
  };
}
function Vr(e, t = 200, n = {}) {
  return On(
    Pr(t, n),
    e
  );
}
function Br(e, t, n = {}) {
  const {
    eventFilter: r = Ir,
    ...o
  } = n, a = On(
    r,
    t
  );
  let s, i, l;
  if (o.flush === "sync") {
    const c = S(!1);
    i = () => {
    }, s = (u) => {
      c.value = !0, u(), c.value = !1;
    }, l = N(
      e,
      (...u) => {
        c.value || a(...u);
      },
      o
    );
  } else {
    const c = [], u = S(0), d = S(0);
    i = () => {
      u.value = d.value;
    }, c.push(
      N(
        e,
        () => {
          d.value++;
        },
        { ...o, flush: "sync" }
      )
    ), s = (f) => {
      const p = d.value;
      f(), u.value += d.value - p;
    }, c.push(
      N(
        e,
        (...f) => {
          const p = u.value > 0 && u.value === d.value;
          u.value = 0, d.value = 0, !p && a(...f);
        },
        o
      )
    ), l = () => {
      c.forEach((f) => f());
    };
  }
  return { stop: l, ignoreUpdates: s, ignorePrevAsyncUpdates: i };
}
function Pe(e) {
  var t;
  const n = ct(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const It = An ? window : void 0;
function He(...e) {
  let t, n, r, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, o] = e, t = It) : [t, n, r, o] = e, !t)
    return Ue;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const a = [], s = () => {
    a.forEach((u) => u()), a.length = 0;
  }, i = (u, d, f, p) => (u.addEventListener(d, f, p), () => u.removeEventListener(d, f, p)), l = N(
    () => [Pe(t), ct(o)],
    ([u, d]) => {
      if (s(), !u)
        return;
      const f = zr(d) ? { ...d } : d;
      a.push(
        ...n.flatMap((p) => r.map((h) => i(u, p, h, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), s();
  };
  return Tr(c), c;
}
let Jt = !1;
function Nr(e, t, n = {}) {
  const { window: r = It, ignore: o = [], capture: a = !0, detectIframe: s = !1 } = n;
  if (!r)
    return;
  Fr && !Jt && (Jt = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", Ue)), r.document.documentElement.addEventListener("click", Ue));
  let i = !0;
  const l = (f) => o.some((p) => {
    if (typeof p == "string")
      return Array.from(r.document.querySelectorAll(p)).some((h) => h === f.target || f.composedPath().includes(h));
    {
      const h = Pe(p);
      return h && (f.target === h || f.composedPath().includes(h));
    }
  }), u = [
    He(r, "click", (f) => {
      const p = Pe(e);
      if (!(!p || p === f.target || f.composedPath().includes(p))) {
        if (f.detail === 0 && (i = !l(f)), !i) {
          i = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: a }),
    He(r, "pointerdown", (f) => {
      const p = Pe(e);
      p && (i = !f.composedPath().includes(p) && !l(f));
    }, { passive: !0 }),
    s && He(r, "blur", (f) => {
      setTimeout(() => {
        var p;
        const h = Pe(e);
        ((p = r.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(h != null && h.contains(r.document.activeElement)) && t(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
function Gr(e = {}) {
  var t;
  const {
    window: n = It,
    deep: r = !0
  } = e, o = (t = e.document) != null ? t : n == null ? void 0 : n.document, a = () => {
    var i;
    let l = o == null ? void 0 : o.activeElement;
    if (r)
      for (; l != null && l.shadowRoot; )
        l = (i = l == null ? void 0 : l.shadowRoot) == null ? void 0 : i.activeElement;
    return l;
  }, s = Dr(
    () => null,
    () => a()
  );
  return n && (He(n, "blur", (i) => {
    i.relatedTarget === null && s.trigger();
  }, !0), He(n, "focus", s.trigger, !0)), s;
}
function Lr(e, t = {}) {
  const n = Gr(t), r = T(() => Pe(e));
  return { focused: T(() => r.value && n.value ? r.value.contains(n.value) : !1) };
}
function jr() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Dn(t)) && (r && (r += " "), r += n);
  return r;
}
function Dn(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = Dn(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Pt = "-";
function Yr(e) {
  var t = Hr(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function a(i) {
    var l = i.split(Pt);
    return l[0] === "" && l.length !== 1 && l.shift(), Tn(l, t) || Wr(i);
  }
  function s(i, l) {
    var c = n[i] || [];
    return l && o[i] ? [].concat(c, o[i]) : c;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: s
  };
}
function Tn(e, t) {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? Tn(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var a = e.join(Pt);
    return (s = t.validators.find(function(i) {
      var l = i.validator;
      return l(a);
    })) == null ? void 0 : s.classGroupId;
  }
}
var Zt = /^\[(.+)\]$/;
function Wr(e) {
  if (Zt.test(e)) {
    var t = Zt.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Hr(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = qr(Object.entries(e.classGroups), n);
  return o.forEach(function(a) {
    var s = a[0], i = a[1];
    Mt(i, r, s, t);
  }), r;
}
function Mt(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var a = o === "" ? t : en(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Kr(o)) {
        Mt(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(s) {
      var i = s[0], l = s[1];
      Mt(l, en(t, i), n, r);
    });
  });
}
function en(e, t) {
  var n = e;
  return t.split(Pt).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function Kr(e) {
  return e.isThemeGetter;
}
function qr(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], a = o.map(function(s) {
      return typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(i) {
        var l = i[0], c = i[1];
        return [t + l, c];
      })) : s;
    });
    return [r, a];
  }) : e;
}
function Ur(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(a, s) {
    n.set(a, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var i = n.get(s);
      if (i !== void 0)
        return i;
      if ((i = r.get(s)) !== void 0)
        return o(s, i), i;
    },
    set: function(s, i) {
      n.has(s) ? n.set(s, i) : o(s, i);
    }
  };
}
var En = "!";
function Xr(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(s) {
    for (var i = [], l = 0, c = 0, u, d = 0; d < s.length; d++) {
      var f = s[d];
      if (l === 0) {
        if (f === r && (n || s.slice(d, d + o) === t)) {
          i.push(s.slice(c, d)), c = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? l++ : f === "]" && l--;
    }
    var p = i.length === 0 ? s : s.substring(c), h = p.startsWith(En), g = h ? p.substring(1) : p, b = u && u > c ? u - c : void 0;
    return {
      modifiers: i,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: b
    };
  };
}
function Qr(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function Jr(e) {
  return {
    cache: Ur(e.cacheSize),
    splitModifiers: Xr(e),
    ...Yr(e)
  };
}
var Zr = /\s+/;
function eo(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(Zr).map(function(s) {
    var i = n(s), l = i.modifiers, c = i.hasImportantModifier, u = i.baseClassName, d = i.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), p = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      p = !1;
    }
    var h = Qr(l).join(":"), g = c ? h + En : h;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: s,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var i = s.modifierId, l = s.classGroupId, c = s.hasPostfixModifier, u = i + l;
    return a.has(u) ? !1 : (a.add(u), o(l, c).forEach(function(d) {
      return a.add(i + d);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function tn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, a, s = i;
  function i(c) {
    var u = t[0], d = t.slice(1), f = d.reduce(function(p, h) {
      return h(p);
    }, u());
    return r = Jr(f), o = r.cache.get, a = r.cache.set, s = l, l(c);
  }
  function l(c) {
    var u = o(c);
    if (u)
      return u;
    var d = eo(c, r);
    return a(c, d), d;
  }
  return function() {
    return s(jr.apply(null, arguments));
  };
}
function Y(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var zn = /^\[(?:([a-z-]+):)?(.+)\]$/i, to = /^\d+\/\d+$/, no = /* @__PURE__ */ new Set(["px", "full", "screen"]), ro = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, oo = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ao = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function he(e) {
  return $e(e) || no.has(e) || to.test(e) || At(e);
}
function At(e) {
  return Ee(e, "length", fo);
}
function so(e) {
  return Ee(e, "size", Fn);
}
function lo(e) {
  return Ee(e, "position", Fn);
}
function io(e) {
  return Ee(e, "url", po);
}
function ot(e) {
  return Ee(e, "number", $e);
}
function $e(e) {
  return !Number.isNaN(Number(e));
}
function co(e) {
  return e.endsWith("%") && $e(e.slice(0, -1));
}
function Ye(e) {
  return nn(e) || Ee(e, "number", nn);
}
function z(e) {
  return zn.test(e);
}
function We() {
  return !0;
}
function xe(e) {
  return ro.test(e);
}
function uo(e) {
  return Ee(e, "", go);
}
function Ee(e, t, n) {
  var r = zn.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function fo(e) {
  return oo.test(e);
}
function Fn() {
  return !1;
}
function po(e) {
  return e.startsWith("url(");
}
function nn(e) {
  return Number.isInteger(Number(e));
}
function go(e) {
  return ao.test(e);
}
function rn() {
  var e = Y("colors"), t = Y("spacing"), n = Y("blur"), r = Y("brightness"), o = Y("borderColor"), a = Y("borderRadius"), s = Y("borderSpacing"), i = Y("borderWidth"), l = Y("contrast"), c = Y("grayscale"), u = Y("hueRotate"), d = Y("invert"), f = Y("gap"), p = Y("gradientColorStops"), h = Y("gradientColorStopPositions"), g = Y("inset"), b = Y("margin"), m = Y("opacity"), C = Y("padding"), A = Y("saturate"), W = Y("scale"), L = Y("sepia"), Q = Y("skew"), E = Y("space"), te = Y("translate"), I = function() {
    return ["auto", "contain", "none"];
  }, H = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, P = function() {
    return ["auto", z, t];
  }, M = function() {
    return [z, t];
  }, ne = function() {
    return ["", he];
  }, U = function() {
    return ["auto", $e, z];
  }, ie = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, ae = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, pe = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, Ge = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Le = function() {
    return ["", "0", z];
  }, Kt = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, je = function() {
    return [$e, ot];
  }, rt = function() {
    return [$e, z];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [We],
      spacing: [he],
      blur: ["none", "", xe, z],
      brightness: je(),
      borderColor: [e],
      borderRadius: ["none", "", "full", xe, z],
      borderSpacing: M(),
      borderWidth: ne(),
      contrast: je(),
      grayscale: Le(),
      hueRotate: rt(),
      invert: Le(),
      gap: M(),
      gradientColorStops: [e],
      gradientColorStopPositions: [co, At],
      inset: P(),
      margin: P(),
      opacity: je(),
      padding: M(),
      saturate: je(),
      scale: je(),
      sepia: Le(),
      skew: rt(),
      space: M(),
      translate: M()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", z]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [xe]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Kt()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Kt()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(ie(), [z])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: H()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": H()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": H()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ye]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", z]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Le()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Le()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ye]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [We]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ye]
        }, z]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [We]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ye]
        }, z]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", z]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", z]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(Ge())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(Ge(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(Ge(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", z, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", z, he]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [xe]
        }, xe, z]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [z, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", z, he]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [z, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", xe, At]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ot]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [We]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", z]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", $e, ot]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", z, he]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", z]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", z]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(ae(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", he]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", z, he]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", z]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", z]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(ie(), [lo])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", so]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, io]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(ae(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ae()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(ae())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [z, he]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [he]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ne()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [he]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", xe, uo]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [We]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": pe()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": pe()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", xe, z]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [A]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [L]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [A]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [L]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", z]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: rt()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", z]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: rt()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", z]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [W]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [W]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [W]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ye, z]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [te]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [te]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [Q]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [Q]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", z]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", z]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", z]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [he, ot]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function ho(e, t) {
  for (var n in t)
    Rn(e, n, t[n]);
  return e;
}
var vo = Object.prototype.hasOwnProperty, mo = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function Rn(e, t, n) {
  if (!vo.call(e, t) || mo.has(typeof n) || n === null) {
    e[t] = n;
    return;
  }
  if (Array.isArray(n) && Array.isArray(e[t])) {
    e[t] = e[t].concat(n);
    return;
  }
  if (typeof n == "object" && typeof e[t] == "object") {
    if (e[t] === null) {
      e[t] = n;
      return;
    }
    for (var r in n)
      Rn(e[t], r, n[r]);
  }
}
function bo(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return typeof e == "function" ? tn.apply(void 0, [rn, e].concat(n)) : tn.apply(void 0, [function() {
    return ho(rn(), e);
  }].concat(n));
}
function yo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var In = { exports: {} }, Pn = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Vn = { exports: {} }, wo = function(t) {
  return !t || typeof t == "string" ? !1 : t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && t.constructor.name !== "String");
}, ko = wo, xo = Array.prototype.concat, _o = Array.prototype.slice, on = Vn.exports = function(t) {
  for (var n = [], r = 0, o = t.length; r < o; r++) {
    var a = t[r];
    ko(a) ? n = xo.call(n, _o.call(a)) : n.push(a);
  }
  return n;
};
on.wrap = function(e) {
  return function() {
    return e(on(arguments));
  };
};
var Co = Vn.exports, Ke = Pn, Ze = Co, Bn = Object.hasOwnProperty, Nn = /* @__PURE__ */ Object.create(null);
for (var St in Ke)
  Bn.call(Ke, St) && (Nn[Ke[St]] = St);
var de = In.exports = {
  to: {},
  get: {}
};
de.get = function(e) {
  var t = e.substring(0, 3).toLowerCase(), n, r;
  switch (t) {
    case "hsl":
      n = de.get.hsl(e), r = "hsl";
      break;
    case "hwb":
      n = de.get.hwb(e), r = "hwb";
      break;
    default:
      n = de.get.rgb(e), r = "rgb";
      break;
  }
  return n ? { model: r, value: n } : null;
};
de.get.rgb = function(e) {
  if (!e)
    return null;
  var t = /^#([a-f0-9]{3,4})$/i, n = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, r = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, o = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, a = /^(\w+)$/, s = [0, 0, 0, 1], i, l, c;
  if (i = e.match(n)) {
    for (c = i[2], i = i[1], l = 0; l < 3; l++) {
      var u = l * 2;
      s[l] = parseInt(i.slice(u, u + 2), 16);
    }
    c && (s[3] = parseInt(c, 16) / 255);
  } else if (i = e.match(t)) {
    for (i = i[1], c = i[3], l = 0; l < 3; l++)
      s[l] = parseInt(i[l] + i[l], 16);
    c && (s[3] = parseInt(c + c, 16) / 255);
  } else if (i = e.match(r)) {
    for (l = 0; l < 3; l++)
      s[l] = parseInt(i[l + 1], 0);
    i[4] && (i[5] ? s[3] = parseFloat(i[4]) * 0.01 : s[3] = parseFloat(i[4]));
  } else if (i = e.match(o)) {
    for (l = 0; l < 3; l++)
      s[l] = Math.round(parseFloat(i[l + 1]) * 2.55);
    i[4] && (i[5] ? s[3] = parseFloat(i[4]) * 0.01 : s[3] = parseFloat(i[4]));
  } else
    return (i = e.match(a)) ? i[1] === "transparent" ? [0, 0, 0, 0] : Bn.call(Ke, i[1]) ? (s = Ke[i[1]], s[3] = 1, s) : null : null;
  for (l = 0; l < 3; l++)
    s[l] = _e(s[l], 0, 255);
  return s[3] = _e(s[3], 0, 1), s;
};
de.get.hsl = function(e) {
  if (!e)
    return null;
  var t = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = e.match(t);
  if (n) {
    var r = parseFloat(n[4]), o = (parseFloat(n[1]) % 360 + 360) % 360, a = _e(parseFloat(n[2]), 0, 100), s = _e(parseFloat(n[3]), 0, 100), i = _e(isNaN(r) ? 1 : r, 0, 1);
    return [o, a, s, i];
  }
  return null;
};
de.get.hwb = function(e) {
  if (!e)
    return null;
  var t = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = e.match(t);
  if (n) {
    var r = parseFloat(n[4]), o = (parseFloat(n[1]) % 360 + 360) % 360, a = _e(parseFloat(n[2]), 0, 100), s = _e(parseFloat(n[3]), 0, 100), i = _e(isNaN(r) ? 1 : r, 0, 1);
    return [o, a, s, i];
  }
  return null;
};
de.to.hex = function() {
  var e = Ze(arguments);
  return "#" + at(e[0]) + at(e[1]) + at(e[2]) + (e[3] < 1 ? at(Math.round(e[3] * 255)) : "");
};
de.to.rgb = function() {
  var e = Ze(arguments);
  return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
};
de.to.rgb.percent = function() {
  var e = Ze(arguments), t = Math.round(e[0] / 255 * 100), n = Math.round(e[1] / 255 * 100), r = Math.round(e[2] / 255 * 100);
  return e.length < 4 || e[3] === 1 ? "rgb(" + t + "%, " + n + "%, " + r + "%)" : "rgba(" + t + "%, " + n + "%, " + r + "%, " + e[3] + ")";
};
de.to.hsl = function() {
  var e = Ze(arguments);
  return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
};
de.to.hwb = function() {
  var e = Ze(arguments), t = "";
  return e.length >= 4 && e[3] !== 1 && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
};
de.to.keyword = function(e) {
  return Nn[e.slice(0, 3)];
};
function _e(e, t, n) {
  return Math.min(Math.max(t, e), n);
}
function at(e) {
  var t = Math.round(e).toString(16).toUpperCase();
  return t.length < 2 ? "0" + t : t;
}
var So = In.exports;
const Xe = Pn, Gn = {};
for (const e of Object.keys(Xe))
  Gn[Xe[e]] = e;
const w = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var Ln = w;
for (const e of Object.keys(w)) {
  if (!("channels" in w[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in w[e]))
    throw new Error("missing channel labels property: " + e);
  if (w[e].labels.length !== w[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: t, labels: n } = w[e];
  delete w[e].channels, delete w[e].labels, Object.defineProperty(w[e], "channels", { value: t }), Object.defineProperty(w[e], "labels", { value: n });
}
w.rgb.hsl = function(e) {
  const t = e[0] / 255, n = e[1] / 255, r = e[2] / 255, o = Math.min(t, n, r), a = Math.max(t, n, r), s = a - o;
  let i, l;
  a === o ? i = 0 : t === a ? i = (n - r) / s : n === a ? i = 2 + (r - t) / s : r === a && (i = 4 + (t - n) / s), i = Math.min(i * 60, 360), i < 0 && (i += 360);
  const c = (o + a) / 2;
  return a === o ? l = 0 : c <= 0.5 ? l = s / (a + o) : l = s / (2 - a - o), [i, l * 100, c * 100];
};
w.rgb.hsv = function(e) {
  let t, n, r, o, a;
  const s = e[0] / 255, i = e[1] / 255, l = e[2] / 255, c = Math.max(s, i, l), u = c - Math.min(s, i, l), d = function(f) {
    return (c - f) / 6 / u + 1 / 2;
  };
  return u === 0 ? (o = 0, a = 0) : (a = u / c, t = d(s), n = d(i), r = d(l), s === c ? o = r - n : i === c ? o = 1 / 3 + t - r : l === c && (o = 2 / 3 + n - t), o < 0 ? o += 1 : o > 1 && (o -= 1)), [
    o * 360,
    a * 100,
    c * 100
  ];
};
w.rgb.hwb = function(e) {
  const t = e[0], n = e[1];
  let r = e[2];
  const o = w.rgb.hsl(e)[0], a = 1 / 255 * Math.min(t, Math.min(n, r));
  return r = 1 - 1 / 255 * Math.max(t, Math.max(n, r)), [o, a * 100, r * 100];
};
w.rgb.cmyk = function(e) {
  const t = e[0] / 255, n = e[1] / 255, r = e[2] / 255, o = Math.min(1 - t, 1 - n, 1 - r), a = (1 - t - o) / (1 - o) || 0, s = (1 - n - o) / (1 - o) || 0, i = (1 - r - o) / (1 - o) || 0;
  return [a * 100, s * 100, i * 100, o * 100];
};
function $o(e, t) {
  return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
}
w.rgb.keyword = function(e) {
  const t = Gn[e];
  if (t)
    return t;
  let n = 1 / 0, r;
  for (const o of Object.keys(Xe)) {
    const a = Xe[o], s = $o(e, a);
    s < n && (n = s, r = o);
  }
  return r;
};
w.keyword.rgb = function(e) {
  return Xe[e];
};
w.rgb.xyz = function(e) {
  let t = e[0] / 255, n = e[1] / 255, r = e[2] / 255;
  t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  const o = t * 0.4124 + n * 0.3576 + r * 0.1805, a = t * 0.2126 + n * 0.7152 + r * 0.0722, s = t * 0.0193 + n * 0.1192 + r * 0.9505;
  return [o * 100, a * 100, s * 100];
};
w.rgb.lab = function(e) {
  const t = w.rgb.xyz(e);
  let n = t[0], r = t[1], o = t[2];
  n /= 95.047, r /= 100, o /= 108.883, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, o = o > 8856e-6 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
  const a = 116 * r - 16, s = 500 * (n - r), i = 200 * (r - o);
  return [a, s, i];
};
w.hsl.rgb = function(e) {
  const t = e[0] / 360, n = e[1] / 100, r = e[2] / 100;
  let o, a, s;
  if (n === 0)
    return s = r * 255, [s, s, s];
  r < 0.5 ? o = r * (1 + n) : o = r + n - r * n;
  const i = 2 * r - o, l = [0, 0, 0];
  for (let c = 0; c < 3; c++)
    a = t + 1 / 3 * -(c - 1), a < 0 && a++, a > 1 && a--, 6 * a < 1 ? s = i + (o - i) * 6 * a : 2 * a < 1 ? s = o : 3 * a < 2 ? s = i + (o - i) * (2 / 3 - a) * 6 : s = i, l[c] = s * 255;
  return l;
};
w.hsl.hsv = function(e) {
  const t = e[0];
  let n = e[1] / 100, r = e[2] / 100, o = n;
  const a = Math.max(r, 0.01);
  r *= 2, n *= r <= 1 ? r : 2 - r, o *= a <= 1 ? a : 2 - a;
  const s = (r + n) / 2, i = r === 0 ? 2 * o / (a + o) : 2 * n / (r + n);
  return [t, i * 100, s * 100];
};
w.hsv.rgb = function(e) {
  const t = e[0] / 60, n = e[1] / 100;
  let r = e[2] / 100;
  const o = Math.floor(t) % 6, a = t - Math.floor(t), s = 255 * r * (1 - n), i = 255 * r * (1 - n * a), l = 255 * r * (1 - n * (1 - a));
  switch (r *= 255, o) {
    case 0:
      return [r, l, s];
    case 1:
      return [i, r, s];
    case 2:
      return [s, r, l];
    case 3:
      return [s, i, r];
    case 4:
      return [l, s, r];
    case 5:
      return [r, s, i];
  }
};
w.hsv.hsl = function(e) {
  const t = e[0], n = e[1] / 100, r = e[2] / 100, o = Math.max(r, 0.01);
  let a, s;
  s = (2 - n) * r;
  const i = (2 - n) * o;
  return a = n * o, a /= i <= 1 ? i : 2 - i, a = a || 0, s /= 2, [t, a * 100, s * 100];
};
w.hwb.rgb = function(e) {
  const t = e[0] / 360;
  let n = e[1] / 100, r = e[2] / 100;
  const o = n + r;
  let a;
  o > 1 && (n /= o, r /= o);
  const s = Math.floor(6 * t), i = 1 - r;
  a = 6 * t - s, s & 1 && (a = 1 - a);
  const l = n + a * (i - n);
  let c, u, d;
  switch (s) {
    default:
    case 6:
    case 0:
      c = i, u = l, d = n;
      break;
    case 1:
      c = l, u = i, d = n;
      break;
    case 2:
      c = n, u = i, d = l;
      break;
    case 3:
      c = n, u = l, d = i;
      break;
    case 4:
      c = l, u = n, d = i;
      break;
    case 5:
      c = i, u = n, d = l;
      break;
  }
  return [c * 255, u * 255, d * 255];
};
w.cmyk.rgb = function(e) {
  const t = e[0] / 100, n = e[1] / 100, r = e[2] / 100, o = e[3] / 100, a = 1 - Math.min(1, t * (1 - o) + o), s = 1 - Math.min(1, n * (1 - o) + o), i = 1 - Math.min(1, r * (1 - o) + o);
  return [a * 255, s * 255, i * 255];
};
w.xyz.rgb = function(e) {
  const t = e[0] / 100, n = e[1] / 100, r = e[2] / 100;
  let o, a, s;
  return o = t * 3.2406 + n * -1.5372 + r * -0.4986, a = t * -0.9689 + n * 1.8758 + r * 0.0415, s = t * 0.0557 + n * -0.204 + r * 1.057, o = o > 31308e-7 ? 1.055 * o ** (1 / 2.4) - 0.055 : o * 12.92, a = a > 31308e-7 ? 1.055 * a ** (1 / 2.4) - 0.055 : a * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, o = Math.min(Math.max(0, o), 1), a = Math.min(Math.max(0, a), 1), s = Math.min(Math.max(0, s), 1), [o * 255, a * 255, s * 255];
};
w.xyz.lab = function(e) {
  let t = e[0], n = e[1], r = e[2];
  t /= 95.047, n /= 100, r /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116;
  const o = 116 * n - 16, a = 500 * (t - n), s = 200 * (n - r);
  return [o, a, s];
};
w.lab.xyz = function(e) {
  const t = e[0], n = e[1], r = e[2];
  let o, a, s;
  a = (t + 16) / 116, o = n / 500 + a, s = a - r / 200;
  const i = a ** 3, l = o ** 3, c = s ** 3;
  return a = i > 8856e-6 ? i : (a - 16 / 116) / 7.787, o = l > 8856e-6 ? l : (o - 16 / 116) / 7.787, s = c > 8856e-6 ? c : (s - 16 / 116) / 7.787, o *= 95.047, a *= 100, s *= 108.883, [o, a, s];
};
w.lab.lch = function(e) {
  const t = e[0], n = e[1], r = e[2];
  let o;
  o = Math.atan2(r, n) * 360 / 2 / Math.PI, o < 0 && (o += 360);
  const s = Math.sqrt(n * n + r * r);
  return [t, s, o];
};
w.lch.lab = function(e) {
  const t = e[0], n = e[1], o = e[2] / 360 * 2 * Math.PI, a = n * Math.cos(o), s = n * Math.sin(o);
  return [t, a, s];
};
w.rgb.ansi16 = function(e, t = null) {
  const [n, r, o] = e;
  let a = t === null ? w.rgb.hsv(e)[2] : t;
  if (a = Math.round(a / 50), a === 0)
    return 30;
  let s = 30 + (Math.round(o / 255) << 2 | Math.round(r / 255) << 1 | Math.round(n / 255));
  return a === 2 && (s += 60), s;
};
w.hsv.ansi16 = function(e) {
  return w.rgb.ansi16(w.hsv.rgb(e), e[2]);
};
w.rgb.ansi256 = function(e) {
  const t = e[0], n = e[1], r = e[2];
  return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
};
w.ansi16.rgb = function(e) {
  let t = e % 10;
  if (t === 0 || t === 7)
    return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
  const n = (~~(e > 50) + 1) * 0.5, r = (t & 1) * n * 255, o = (t >> 1 & 1) * n * 255, a = (t >> 2 & 1) * n * 255;
  return [r, o, a];
};
w.ansi256.rgb = function(e) {
  if (e >= 232) {
    const a = (e - 232) * 10 + 8;
    return [a, a, a];
  }
  e -= 16;
  let t;
  const n = Math.floor(e / 36) / 5 * 255, r = Math.floor((t = e % 36) / 6) / 5 * 255, o = t % 6 / 5 * 255;
  return [n, r, o];
};
w.rgb.hex = function(e) {
  const n = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
w.hex.rgb = function(e) {
  const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!t)
    return [0, 0, 0];
  let n = t[0];
  t[0].length === 3 && (n = n.split("").map((i) => i + i).join(""));
  const r = parseInt(n, 16), o = r >> 16 & 255, a = r >> 8 & 255, s = r & 255;
  return [o, a, s];
};
w.rgb.hcg = function(e) {
  const t = e[0] / 255, n = e[1] / 255, r = e[2] / 255, o = Math.max(Math.max(t, n), r), a = Math.min(Math.min(t, n), r), s = o - a;
  let i, l;
  return s < 1 ? i = a / (1 - s) : i = 0, s <= 0 ? l = 0 : o === t ? l = (n - r) / s % 6 : o === n ? l = 2 + (r - t) / s : l = 4 + (t - n) / s, l /= 6, l %= 1, [l * 360, s * 100, i * 100];
};
w.hsl.hcg = function(e) {
  const t = e[1] / 100, n = e[2] / 100, r = n < 0.5 ? 2 * t * n : 2 * t * (1 - n);
  let o = 0;
  return r < 1 && (o = (n - 0.5 * r) / (1 - r)), [e[0], r * 100, o * 100];
};
w.hsv.hcg = function(e) {
  const t = e[1] / 100, n = e[2] / 100, r = t * n;
  let o = 0;
  return r < 1 && (o = (n - r) / (1 - r)), [e[0], r * 100, o * 100];
};
w.hcg.rgb = function(e) {
  const t = e[0] / 360, n = e[1] / 100, r = e[2] / 100;
  if (n === 0)
    return [r * 255, r * 255, r * 255];
  const o = [0, 0, 0], a = t % 1 * 6, s = a % 1, i = 1 - s;
  let l = 0;
  switch (Math.floor(a)) {
    case 0:
      o[0] = 1, o[1] = s, o[2] = 0;
      break;
    case 1:
      o[0] = i, o[1] = 1, o[2] = 0;
      break;
    case 2:
      o[0] = 0, o[1] = 1, o[2] = s;
      break;
    case 3:
      o[0] = 0, o[1] = i, o[2] = 1;
      break;
    case 4:
      o[0] = s, o[1] = 0, o[2] = 1;
      break;
    default:
      o[0] = 1, o[1] = 0, o[2] = i;
  }
  return l = (1 - n) * r, [
    (n * o[0] + l) * 255,
    (n * o[1] + l) * 255,
    (n * o[2] + l) * 255
  ];
};
w.hcg.hsv = function(e) {
  const t = e[1] / 100, n = e[2] / 100, r = t + n * (1 - t);
  let o = 0;
  return r > 0 && (o = t / r), [e[0], o * 100, r * 100];
};
w.hcg.hsl = function(e) {
  const t = e[1] / 100, r = e[2] / 100 * (1 - t) + 0.5 * t;
  let o = 0;
  return r > 0 && r < 0.5 ? o = t / (2 * r) : r >= 0.5 && r < 1 && (o = t / (2 * (1 - r))), [e[0], o * 100, r * 100];
};
w.hcg.hwb = function(e) {
  const t = e[1] / 100, n = e[2] / 100, r = t + n * (1 - t);
  return [e[0], (r - t) * 100, (1 - r) * 100];
};
w.hwb.hcg = function(e) {
  const t = e[1] / 100, r = 1 - e[2] / 100, o = r - t;
  let a = 0;
  return o < 1 && (a = (r - o) / (1 - o)), [e[0], o * 100, a * 100];
};
w.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
w.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
w.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
w.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
w.gray.hsv = w.gray.hsl;
w.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
w.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
w.gray.lab = function(e) {
  return [e[0], 0, 0];
};
w.gray.hex = function(e) {
  const t = Math.round(e[0] / 100 * 255) & 255, r = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
w.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
const ut = Ln;
function Mo() {
  const e = {}, t = Object.keys(ut);
  for (let n = t.length, r = 0; r < n; r++)
    e[t[r]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function Ao(e) {
  const t = Mo(), n = [e];
  for (t[e].distance = 0; n.length; ) {
    const r = n.pop(), o = Object.keys(ut[r]);
    for (let a = o.length, s = 0; s < a; s++) {
      const i = o[s], l = t[i];
      l.distance === -1 && (l.distance = t[r].distance + 1, l.parent = r, n.unshift(i));
    }
  }
  return t;
}
function Oo(e, t) {
  return function(n) {
    return t(e(n));
  };
}
function Do(e, t) {
  const n = [t[e].parent, e];
  let r = ut[t[e].parent][e], o = t[e].parent;
  for (; t[o].parent; )
    n.unshift(t[o].parent), r = Oo(ut[t[o].parent][o], r), o = t[o].parent;
  return r.conversion = n, r;
}
var To = function(e) {
  const t = Ao(e), n = {}, r = Object.keys(t);
  for (let o = r.length, a = 0; a < o; a++) {
    const s = r[a];
    t[s].parent !== null && (n[s] = Do(s, t));
  }
  return n;
};
const Ot = Ln, Eo = To, Re = {}, zo = Object.keys(Ot);
function Fo(e) {
  const t = function(...n) {
    const r = n[0];
    return r == null ? r : (r.length > 1 && (n = r), e(n));
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
function Ro(e) {
  const t = function(...n) {
    const r = n[0];
    if (r == null)
      return r;
    r.length > 1 && (n = r);
    const o = e(n);
    if (typeof o == "object")
      for (let a = o.length, s = 0; s < a; s++)
        o[s] = Math.round(o[s]);
    return o;
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
zo.forEach((e) => {
  Re[e] = {}, Object.defineProperty(Re[e], "channels", { value: Ot[e].channels }), Object.defineProperty(Re[e], "labels", { value: Ot[e].labels });
  const t = Eo(e);
  Object.keys(t).forEach((r) => {
    const o = t[r];
    Re[e][r] = Ro(o), Re[e][r].raw = Fo(o);
  });
});
var Io = Re;
const Ie = So, ue = Io, jn = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
], Dt = {};
for (const e of Object.keys(ue))
  Dt[[...ue[e].labels].sort().join("")] = e;
const dt = {};
function J(e, t) {
  if (!(this instanceof J))
    return new J(e, t);
  if (t && t in jn && (t = null), t && !(t in ue))
    throw new Error("Unknown model: " + t);
  let n, r;
  if (e == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (e instanceof J)
    this.model = e.model, this.color = [...e.color], this.valpha = e.valpha;
  else if (typeof e == "string") {
    const o = Ie.get(e);
    if (o === null)
      throw new Error("Unable to parse color from string: " + e);
    this.model = o.model, r = ue[this.model].channels, this.color = o.value.slice(0, r), this.valpha = typeof o.value[r] == "number" ? o.value[r] : 1;
  } else if (e.length > 0) {
    this.model = t || "rgb", r = ue[this.model].channels;
    const o = Array.prototype.slice.call(e, 0, r);
    this.color = Tt(o, r), this.valpha = typeof e[r] == "number" ? e[r] : 1;
  } else if (typeof e == "number")
    this.model = "rgb", this.color = [
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const o = Object.keys(e);
    "alpha" in e && (o.splice(o.indexOf("alpha"), 1), this.valpha = typeof e.alpha == "number" ? e.alpha : 0);
    const a = o.sort().join("");
    if (!(a in Dt))
      throw new Error("Unable to parse color from object: " + JSON.stringify(e));
    this.model = Dt[a];
    const { labels: s } = ue[this.model], i = [];
    for (n = 0; n < s.length; n++)
      i.push(e[s[n]]);
    this.color = Tt(i);
  }
  if (dt[this.model])
    for (r = ue[this.model].channels, n = 0; n < r; n++) {
      const o = dt[this.model][n];
      o && (this.color[n] = o(this.color[n]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
J.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(e) {
    let t = this.model in Ie.to ? this : this.rgb();
    t = t.round(typeof e == "number" ? e : 1);
    const n = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return Ie.to[t.model](n);
  },
  percentString(e) {
    const t = this.rgb().round(typeof e == "number" ? e : 1), n = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return Ie.to.rgb.percent(n);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const e = {}, { channels: t } = ue[this.model], { labels: n } = ue[this.model];
    for (let r = 0; r < t; r++)
      e[n[r]] = this.color[r];
    return this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  unitArray() {
    const e = this.rgb().color;
    return e[0] /= 255, e[1] /= 255, e[2] /= 255, this.valpha !== 1 && e.push(this.valpha), e;
  },
  unitObject() {
    const e = this.rgb().object();
    return e.r /= 255, e.g /= 255, e.b /= 255, this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  round(e) {
    return e = Math.max(e || 0, 0), new J([...this.color.map(Vo(e)), this.valpha], this.model);
  },
  alpha(e) {
    return e !== void 0 ? new J([...this.color, Math.max(0, Math.min(1, e))], this.model) : this.valpha;
  },
  // Rgb
  red: K("rgb", 0, X(255)),
  green: K("rgb", 1, X(255)),
  blue: K("rgb", 2, X(255)),
  hue: K(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (e) => (e % 360 + 360) % 360),
  saturationl: K("hsl", 1, X(100)),
  lightness: K("hsl", 2, X(100)),
  saturationv: K("hsv", 1, X(100)),
  value: K("hsv", 2, X(100)),
  chroma: K("hcg", 1, X(100)),
  gray: K("hcg", 2, X(100)),
  white: K("hwb", 1, X(100)),
  wblack: K("hwb", 2, X(100)),
  cyan: K("cmyk", 0, X(100)),
  magenta: K("cmyk", 1, X(100)),
  yellow: K("cmyk", 2, X(100)),
  black: K("cmyk", 3, X(100)),
  x: K("xyz", 0, X(95.047)),
  y: K("xyz", 1, X(100)),
  z: K("xyz", 2, X(108.833)),
  l: K("lab", 0, X(100)),
  a: K("lab", 1),
  b: K("lab", 2),
  keyword(e) {
    return e !== void 0 ? new J(e) : ue[this.model].keyword(this.color);
  },
  hex(e) {
    return e !== void 0 ? new J(e) : Ie.to.hex(this.rgb().round().color);
  },
  hexa(e) {
    if (e !== void 0)
      return new J(e);
    const t = this.rgb().round().color;
    let n = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return n.length === 1 && (n = "0" + n), Ie.to.hex(t) + n;
  },
  rgbNumber() {
    const e = this.rgb().color;
    return (e[0] & 255) << 16 | (e[1] & 255) << 8 | e[2] & 255;
  },
  luminosity() {
    const e = this.rgb().color, t = [];
    for (const [n, r] of e.entries()) {
      const o = r / 255;
      t[n] = o <= 0.04045 ? o / 12.92 : ((o + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2];
  },
  contrast(e) {
    const t = this.luminosity(), n = e.luminosity();
    return t > n ? (t + 0.05) / (n + 0.05) : (n + 0.05) / (t + 0.05);
  },
  level(e) {
    const t = this.contrast(e);
    return t >= 7 ? "AAA" : t >= 4.5 ? "AA" : "";
  },
  isDark() {
    const e = this.rgb().color;
    return (e[0] * 2126 + e[1] * 7152 + e[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const e = this.rgb();
    for (let t = 0; t < 3; t++)
      e.color[t] = 255 - e.color[t];
    return e;
  },
  lighten(e) {
    const t = this.hsl();
    return t.color[2] += t.color[2] * e, t;
  },
  darken(e) {
    const t = this.hsl();
    return t.color[2] -= t.color[2] * e, t;
  },
  saturate(e) {
    const t = this.hsl();
    return t.color[1] += t.color[1] * e, t;
  },
  desaturate(e) {
    const t = this.hsl();
    return t.color[1] -= t.color[1] * e, t;
  },
  whiten(e) {
    const t = this.hwb();
    return t.color[1] += t.color[1] * e, t;
  },
  blacken(e) {
    const t = this.hwb();
    return t.color[2] += t.color[2] * e, t;
  },
  grayscale() {
    const e = this.rgb().color, t = e[0] * 0.3 + e[1] * 0.59 + e[2] * 0.11;
    return J.rgb(t, t, t);
  },
  fade(e) {
    return this.alpha(this.valpha - this.valpha * e);
  },
  opaquer(e) {
    return this.alpha(this.valpha + this.valpha * e);
  },
  rotate(e) {
    const t = this.hsl();
    let n = t.color[0];
    return n = (n + e) % 360, n = n < 0 ? 360 + n : n, t.color[0] = n, t;
  },
  mix(e, t) {
    if (!e || !e.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
    const n = e.rgb(), r = this.rgb(), o = t === void 0 ? 0.5 : t, a = 2 * o - 1, s = n.alpha() - r.alpha(), i = ((a * s === -1 ? a : (a + s) / (1 + a * s)) + 1) / 2, l = 1 - i;
    return J.rgb(
      i * n.red() + l * r.red(),
      i * n.green() + l * r.green(),
      i * n.blue() + l * r.blue(),
      n.alpha() * o + r.alpha() * (1 - o)
    );
  }
};
for (const e of Object.keys(ue)) {
  if (jn.includes(e))
    continue;
  const { channels: t } = ue[e];
  J.prototype[e] = function(...n) {
    return this.model === e ? new J(this) : n.length > 0 ? new J(n, e) : new J([...Bo(ue[this.model][e].raw(this.color)), this.valpha], e);
  }, J[e] = function(...n) {
    let r = n[0];
    return typeof r == "number" && (r = Tt(n, t)), new J(r, e);
  };
}
function Po(e, t) {
  return Number(e.toFixed(t));
}
function Vo(e) {
  return function(t) {
    return Po(t, e);
  };
}
function K(e, t, n) {
  e = Array.isArray(e) ? e : [e];
  for (const r of e)
    (dt[r] || (dt[r] = []))[t] = n;
  return e = e[0], function(r) {
    let o;
    return r !== void 0 ? (n && (r = n(r)), o = this[e](), o.color[t] = r, o) : (o = this[e]().color[t], n && (o = n(o)), o);
  };
}
function X(e) {
  return function(t) {
    return Math.max(0, Math.min(e, t));
  };
}
function Bo(e) {
  return Array.isArray(e) ? e : [e];
}
function Tt(e, t) {
  for (let n = 0; n < t; n++)
    typeof e[n] != "number" && (e[n] = 0);
  return e;
}
var No = J;
const an = /* @__PURE__ */ yo(No), Go = bo({
  theme: {
    colors: [
      "transparent",
      "primary",
      "secondary",
      "tertiary",
      "danger",
      "warning",
      "success",
      "info",
      "black",
      "dark",
      "dark-grey",
      "grey",
      "light-grey",
      "light",
      "white"
    ]
  },
  classGroups: {
    "font-size": [
      "text-body-sm",
      "text-body-md",
      "text-body-lg",
      "text-label-sm",
      "text-label-md",
      "text-label-lg",
      "text-title-sm",
      "text-title-md",
      "text-title-lg",
      "text-headline-sm",
      "text-headline-md",
      "text-headline-lg",
      "text-display-sm",
      "text-display-md",
      "text-display-lg"
    ],
    "box-shadow": ["1", "2", "3", "4", "5"]
  }
});
function G(...e) {
  return Go($(e));
}
function $(e) {
  return e.join(" ");
}
function me(e) {
  const t = getComputedStyle(document.documentElement).getPropertyValue(`--${e}`).split(" ");
  return t ? an({
    r: parseInt(t[0], 10),
    g: parseInt(t[1], 10),
    b: parseInt(t[2], 10)
  }).contrast(an("white")) > 1.8 : !1;
}
const Vt = $([
  "border !border-gray-300 rounded py-2 w-full accent-primary ring-2 ring-primary ring-opacity-0",
  "placeholder:text-dark/50 text-dark",
  "transition",
  "read-only:cursor-not-allowed read-only:bg-gray-200 read-only:text-gray-500",
  "disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500",
  "focus:outline-none focus:ring-opacity-50 focus:!border-primary"
]), Ae = {
  true: $(["!border-success", "focus:ring-success"]),
  false: $(["!border-danger", "focus:ring-danger focus:!border-danger"])
}, Lo = $([
  "text-sm font-medium block cursor-pointer inline-block mb-1",
  "disabled:opacity-50 disabled:cursor-not-allowed"
]), bt = Symbol(), se = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    variant: {},
    size: {},
    block: { type: Boolean },
    debounce: {}
  },
  setup(e) {
    const t = e, n = ee(
      $([
        "bg-primary text-white fill-white flex items-center justify-center rounded font-medium",
        "ring-2 ring-opacity-0 ring-primary",
        "align-middle inline-block select-none",
        "whitespace-nowrap font-normal",
        "border border-transparent",
        "transition",
        "focus:outline-none focus:ring-opacity-50",
        "disabled:opacity-50 disabled:pointer-events-none disabled:saturate-50"
      ]),
      {
        variants: {
          block: {
            true: "w-full"
          },
          variant: {
            primary: $([
              "bg-primary",
              "hover:bg-primary/80",
              me("primary") ? "text-white" : "text-dark"
            ]),
            secondary: $([
              "bg-secondary",
              "hover:bg-secondary/80",
              me("secondary") ? "text-white" : "text-dark"
            ]),
            light: $(["bg-light text-dark fill-dark", "hover:bg-light/80", "focus:ring-light"]),
            dark: $(["bg-dark", "hover:bg-dark/80", "focus:ring-dark"]),
            success: $(["bg-success", "hover:bg-success/80", "focus:ring-success"]),
            danger: $(["bg-danger", "hover:bg-danger/80", "focus:ring-danger"]),
            "outline-primary": $([
              "bg-transparent border border-primary text-primary",
              "hover:!bg-primary",
              me("primary") ? "hover:!text-white" : "hover:!text-dark"
            ]),
            "outline-secondary": $([
              "bg-transparent border border-secondary text-secondary",
              "hover:!bg-secondary",
              me("secondary") ? "hover:!text-white" : "hover:!text-dark"
            ]),
            "outline-light": $([
              "bg-transparent border border-light text-light fill-light",
              "hover:!bg-light hover:!text-dark hover:!fill-dark"
            ]),
            "outline-dark": $([
              "bg-transparent border border-dark text-dark fill-dark",
              "hover:!bg-dark hover:!text-white hover:!fill-white"
            ]),
            "outline-success": $([
              "bg-transparent border border-success text-success fill-success",
              "hover:!bg-success hover:!text-white hover:!fill-white"
            ]),
            "outline-danger": $([
              "bg-transparent border border-danger text-danger fill-danger",
              "hover:!bg-danger hover:!text-white hover:!fill-white"
            ]),
            "outline-white": $([
              "bg-white border border-light text-dark fill-dark",
              "hover:!bg-gray-100 hover:!text-white"
            ]),
            transparent: $(["bg-transparent border border-transparent text-dark fill-dark"])
          },
          size: {
            sm: "text-sm leading-normal py-1 px-2 rounded-[0.25rem]",
            md: "text-base leading-normal py-1.5 px-3 rounded",
            lg: "text-lg leading-normal py-2 px-4 rounded-md"
          }
        },
        defaultVariants: {
          variant: "primary",
          size: "md"
        }
      }
    ), r = vt(bt, void 0), o = ye(), a = o.onClick !== void 0 && t.debounce !== void 0 ? {
      ...o,
      test: !0,
      onClick: Vr(o == null ? void 0 : o.onClick, t.debounce)
    } : o, s = S(
      G(
        n({
          ...t,
          size: r || t.size
        })
      )
    );
    return N(
      [() => t.variant, () => t.size, () => t.block],
      () => {
        s.value = G(
          n({
            ...t,
            size: r || t.size
          })
        );
      },
      { immediate: !0 }
    ), (i, l) => (v(), y("button", Te({
      tabindex: "0",
      class: s.value
    }, k(a)), [
      _(i.$slots, "default")
    ], 16));
  }
}), Yn = (e, t = "horizontal") => ({
  onKeyDown: (r) => {
    if (!e.value || !r.target)
      return;
    const o = Array.from(e.value.children).flatMap((l) => {
      const c = (d) => d.matches(
        "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex]"
      ) && !d.hasAttribute("disabled");
      let u = c(l) ? l : null;
      if (l.hasAttribute("roving-focus-ignore")) {
        const d = Array.from(l.querySelectorAll("*")).find((f) => c(f));
        d && (u = d);
      }
      return u;
    }).filter((l) => l !== null);
    let a = o.findIndex((l) => l === document.activeElement);
    const s = o.length, i = t === "vertical" ? ["ArrowUp", "ArrowDown"] : ["ArrowLeft", "ArrowRight"];
    if (i.includes(r.code) && s) {
      r.preventDefault();
      const c = r.code === i[0] ? -1 : 1, u = (a + c + s) % s;
      a = u, o[u].focus();
    }
  }
}), Wn = /* @__PURE__ */ F({
  __name: "ButtonGroup",
  props: {
    size: {}
  },
  setup(e) {
    const t = e, n = S(null), { onKeyDown: r } = Yn(n), o = $([
      "inline-flex",
      "[&>*]:!rounded-none",
      "[&>*]:!border-l-0",
      "[&>*:first-child]:!rounded-l [&>*:last-child]:!rounded-r [&>*:first-child]:!border-l"
    ]);
    return mt(bt, t.size || "md"), (a, s) => (v(), y("div", {
      ref_key: "containerRef",
      ref: n,
      role: "group",
      tabindex: "-1",
      class: x(k(o)),
      onKeydown: s[0] || (s[0] = //@ts-ignore
      (...i) => k(r) && k(r)(...i))
    }, [
      _(a.$slots, "default", {
        size: t.size
      })
    ], 34));
  }
}), jo = ["id"], Yo = ["value", "disabled"], Wo = /* @__PURE__ */ F({
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  __name: "Select",
  props: {
    modelValue: {},
    value: {},
    state: {},
    options: {}
  },
  emits: ["update:modelValue", "input"],
  setup(e, { emit: t }) {
    const n = e, r = ee(
      $([
        "text-dark appearance-none inline-block w-full",
        "bg-[center_right_0.75rem] bg-[length:8px_10px] bg-no-repeat",
        "hover:opacity-90",
        "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50",
        "pl-3 pr-8 py-1.5",
        "border border-gray-300 rounded",
        "transition-opacity duration-150 ease-in-out",
        "disabled:opacity-50 disabled:pointer-events-none disabled:bg-gray-200"
      ]),
      {
        variants: {
          block: {
            true: "block"
          },
          state: Ae
        },
        defaultVariants: {}
      }
    ), o = ye(), a = T({
      get() {
        return n.modelValue ?? n.value;
      },
      set(l) {
        t("update:modelValue", l), t("input", l);
      }
    }), s = S(r(n)), i = T(() => o.id || o.name || void 0);
    return (l, c) => Je((v(), y("select", {
      id: i.value,
      "onUpdate:modelValue": c[0] || (c[0] = (u) => a.value = u),
      class: x([s.value, "select-background bg-white"])
    }, [
      _(l.$slots, "first", {}, void 0, !0),
      _(l.$slots, "default", {}, () => [
        (v(!0), y(le, null, Z(l.options, (u, d) => (v(), y("option", {
          key: d,
          value: u.value,
          disabled: u.disabled
        }, B(u.text), 9, Yo))), 128))
      ], !0)
    ], 10, jo)), [
      [hr, a.value]
    ]);
  }
});
const we = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Hn = /* @__PURE__ */ we(Wo, [["__scopeId", "data-v-47a29dab"]]), yt = /* @__PURE__ */ F({
  __name: "Label",
  props: {
    size: {},
    block: {},
    content: {}
  },
  setup(e) {
    const t = e, n = ee(Lo, {
      variants: {
        size: {
          sm: "text-sm",
          default: "text-base",
          lg: "text-lg"
        },
        block: {
          true: "block"
        }
      },
      defaultVariants: {
        size: "default"
      }
    }), r = T(
      () => G(
        n({
          ...t,
          block: t.block !== null
        })
      )
    );
    return (o, a) => (v(), y("label", {
      class: x(r.value)
    }, [
      _(o.$slots, "default")
    ], 2));
  }
}), Ho = /* @__PURE__ */ F({
  name: "GForm",
  __name: "Form",
  setup(e) {
    return (t, n) => (v(), y("form", null, [
      _(t.$slots, "default")
    ]));
  }
}), Ko = ["aria-live", "aria-hidden"], Kn = /* @__PURE__ */ F({
  __name: "FormFeedback",
  props: {
    state: {}
  },
  setup(e) {
    const t = e, n = ee("block text-xs mt-1", {
      variants: {
        state: {
          true: "text-green-500",
          false: "text-red-500",
          null: "text-gray-500"
        }
      },
      defaultVariants: {
        state: null
      }
    }), r = S(G(n(t)));
    return N(
      () => t.state,
      () => {
        r.value = G(n(t));
      }
    ), (o, a) => o.state !== null ? (v(), y("span", {
      key: 0,
      role: "alert",
      class: x(r.value),
      "aria-live": o.state === null ? "off" : "polite",
      "aria-hidden": o.state === null
    }, [
      _(o.$slots, "default")
    ], 10, Ko)) : R("", !0);
  }
}), qo = ["aria-labelledby", "aria-invalid"], Uo = /* @__PURE__ */ F({
  __name: "FormGroup",
  props: {
    state: { type: [Boolean, null], default: null },
    direction: { default: "col" },
    labelClass: { default: "" },
    validFeedback: {},
    invalidFeedback: {},
    label: {},
    labelFor: {}
  },
  setup(e) {
    const t = e, n = T(() => t.state === !0 && !!t.validFeedback || t.state === !1 && !!t.invalidFeedback);
    return (r, o) => (v(), y("fieldset", {
      role: "group",
      class: x([
        n.value ? "mb-0" : "mb-5",
        "mt-1",
        "flex",
        r.direction === "row" ? "flex-row gap-2" : "flex-col",
        "leading-normal"
      ]),
      "aria-labelledby": r.labelFor,
      "aria-invalid": r.state === !1 ? !0 : void 0
    }, [
      _(r.$slots, "label", {}, () => [
        r.label ? (v(), q(yt, {
          key: 0,
          for: r.labelFor,
          class: x(["mb-2", r.labelClass])
        }, {
          default: O(() => [
            V(B(r.label), 1)
          ]),
          _: 1
        }, 8, ["for", "class"])) : R("", !0)
      ]),
      _(r.$slots, "default"),
      j(Kn, { state: r.state }, {
        default: O(() => [
          V(B(r.state === !0 ? r.validFeedback : r.invalidFeedback), 1)
        ]),
        _: 1
      }, 8, ["state"])
    ], 10, qo));
  }
}), Xo = ["id", "aria-invalid"], qn = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "Input",
  props: {
    modelValue: {},
    value: {},
    size: {},
    state: {},
    formatter: { type: Function },
    lazyFormatter: { type: Boolean }
  },
  emits: ["input", "blur", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = ee(Vt, {
      variants: {
        state: Ae,
        size: {
          sm: "text-sm px-1 h-8 rounded-sm",
          md: "text-base px-2 h-10",
          lg: "text-lg px-3 h-12"
        }
      },
      defaultVariants: {
        size: "md",
        state: null
      }
    }), o = ye(), a = T(() => n.formatter ?? ((p) => p));
    function s(p) {
      return a.value(p);
    }
    const i = T({
      get() {
        return n.modelValue ?? n.value ?? "";
      },
      set(p) {
        n.lazyFormatter || (n.formatter ? t("update:modelValue", s(p)) : t("update:modelValue", p));
      }
    }), l = vt(bt, void 0), c = S(
      G(
        r({
          ...n,
          size: l || n.size
        })
      )
    );
    N(
      [() => n.state, () => n.size],
      () => {
        c.value = G(
          r({
            ...n,
            size: l || n.size
          })
        );
      },
      { immediate: !0 }
    );
    function u(p) {
      t("blur", p.target.value), n.lazyFormatter && t("update:modelValue", s(p.target.value));
    }
    function d(p) {
      n.formatter ? t("input", s(p.target.value)) : t("input", p.target.value);
    }
    const f = T(() => o.id || o.name || void 0);
    return (p, h) => Je((v(), y("input", Te({
      id: f.value,
      "onUpdate:modelValue": h[0] || (h[0] = (g) => i.value = g),
      "aria-invalid": p.state === !1 && p.state !== null ? !0 : void 0,
      class: c.value
    }, k(o), {
      onBlur: u,
      onInput: d
    }), null, 16, Xo)), [
      [vr, i.value]
    ]);
  }
}), Qo = { "data-test-status-badge": "" }, Jo = /* @__PURE__ */ F({
  __name: "Badge",
  props: {
    text: {},
    variant: {},
    pill: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ee(
      $([
        "inline-block px-2 py-0.5",
        "font-semibold  whitespace-nowrap text-[.625rem] leading-[.75rem]",
        "rounded",
        "transition duration-150 ease-in-out"
      ]),
      {
        variants: {
          variant: {
            primary: "bg-primary/20 text-green-700",
            secondary: "bg-secondary/20 text-secondary",
            success: "bg-primary/20 text-green-700",
            danger: "bg-danger/20 text-red-700",
            warning: "bg-warning/20 text-yellow-700",
            info: "bg-info/20 text-blue-700",
            light: "bg-light text-dark",
            dark: "bg-dark text-light",
            blue: "bg-blue-500/20 text-blue-700",
            orange: "bg-orange-500/20 text-orange-700",
            tertiary: "bg-tertiary/20 text-tertiary",
            yellow: "bg-yellow-500/20 text-yellow-700",
            green: "bg-green-500/20 text-green-700"
          },
          pill: {
            true: "rounded-full"
          }
        },
        defaultVariants: {
          variant: "primary"
        }
      }
    ), r = S(G(n(t)));
    return N(
      [() => t.variant, () => t.pill],
      () => {
        r.value = G(n(t));
      },
      { immediate: !0 }
    ), (o, a) => (v(), y("span", {
      class: x(r.value)
    }, [
      _(o.$slots, "default", {}, () => [
        D("span", Qo, B(o.text), 1)
      ])
    ], 2));
  }
}), Zo = ["id", "aria-invalid"], ea = /* @__PURE__ */ F({
  __name: "TextArea",
  props: {
    state: {},
    modelValue: {},
    value: {}
  },
  emits: ["input", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = ee($([Vt, "font-normal text-base px-2"]), {
      variants: {
        state: Ae
      },
      defaultVariants: {
        state: null
      }
    }), o = ye(), a = T({
      get() {
        return n.modelValue ?? n.value ?? "";
      },
      set(c) {
        t("update:modelValue", c);
      }
    }), s = S(G(r(n))), i = T(() => o.id || o.name || void 0);
    function l(c) {
      t("input", c.target.value);
    }
    return N([() => n.state], () => {
      s.value = G(r(n));
    }), (c, u) => Je((v(), y("textarea", Te({
      id: i.value,
      "onUpdate:modelValue": u[0] || (u[0] = (d) => a.value = d),
      "aria-invalid": c.state === !1 && c.state !== null ? !0 : void 0,
      class: s.value
    }, k(o), { onInput: l }), null, 16, Zo)), [
      [mr, a.value]
    ]);
  }
}), ta = ["aria-invalid", "checked", "value"], na = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "Checkbox",
  props: {
    size: {},
    state: {},
    label: {},
    value: {},
    checked: {},
    switch: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e, r = $([
      "appearance-none border aspect-square border-gray-400 rounded m-0 p-0 relative",
      "bg-white bg-center bg-no-repeat",
      "checked:bg-primary checked:!border-primary",
      "disabled:opacity-50 disabled:cursor-not-allowed peer",
      "focus:outline-none focus:ring-2 focus:ring-opacity-50 focus:ring-primary focus:border-primary"
    ]), o = ee(r, {
      variants: {
        size: {
          sm: "w-3 h-3 rounded-sm",
          default: "w-4 h-4",
          lg: "w-5 h-5 rounded"
        },
        switch: {
          true: "w-8 rounded-full",
          false: null
        },
        switchSize: {
          sm: "w-6",
          default: "w-8",
          lg: "w-10"
        },
        state: {
          true: $([Ae.true, "checked:bg-success checked:border-success"]),
          false: $([Ae.false, "checked:bg-danger checked:border-danger"])
        }
      },
      defaultVariants: {
        size: "default",
        state: null,
        switch: null,
        switchSize: null
      }
    }), a = ye(), s = T(
      () => G(
        o({
          state: n.state,
          size: n.size,
          switch: n.switch,
          switchSize: n.switch ? n.size : null
        })
      )
    );
    function i(l) {
      const c = l.target;
      if (n.value === void 0) {
        const { checked: d } = c;
        t("change", d);
        return;
      }
      const u = c.checked ? n.value : null;
      t("change", u);
    }
    return (l, c) => (v(), y("div", {
      class: x(["flex gap-2 max-w-content items-start", { "g-form-switch": n.switch }])
    }, [
      D("input", Te({
        class: [s.value, "g-form-check-input"],
        type: "checkbox",
        "aria-invalid": l.state === !1 && l.state !== null ? !0 : void 0
      }, k(a), {
        checked: l.checked,
        value: l.value,
        onChange: i
      }), null, 16, ta),
      j(yt, {
        size: l.size,
        for: k(a).id,
        class: "peer-disabled:opacity-50 peer-disabled:cursor-not-allowed !m-0 !p-0 relative -top-1"
      }, {
        default: O(() => [
          V(B(l.label) + " ", 1),
          _(l.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["size", "for"])
    ], 2));
  }
});
const qe = /* @__PURE__ */ we(na, [["__scopeId", "data-v-c6948f13"]]), Un = /* @__PURE__ */ F({
  __name: "Spinner",
  props: {
    variant: {},
    size: {}
  },
  setup(e) {
    const t = e, n = ee(
      $([
        "relative aspect-square inline-block animate-spin",
        "before:aspect-square before:w-full",
        "before:rounded-full",
        "before:border-t-primary",
        "before:box-border before:absolute before:inset-0",
        "before:empty-content"
      ]),
      {
        variants: {
          size: {
            sm: "w-4 before:border-2",
            md: "w-8 before:border-4",
            lg: "w-10 before:border-6"
          },
          variant: {
            primary: $([
              me("primary") ? "before:border-light" : "before:border-dark",
              "before:border-t-primary"
            ]),
            secondary: $([
              me("secondary") ? "before:border-light" : "before:border-dark",
              "before:border-t-secondary"
            ]),
            success: "before:border-t-success",
            danger: "before:border-t-danger",
            warning: "before:border-t-warning",
            info: "before:border-t-info",
            light: "before:border-transparent before:border-t-gray-300",
            dark: "before:border-t-dark"
          }
        },
        defaultVariants: {
          size: "md",
          variant: "secondary"
        }
      }
    ), r = S(G(n(t)));
    return N(
      [() => t.size, () => t.variant],
      () => {
        r.value = G(n(t));
      },
      { immediate: !0 }
    ), (o, a) => (v(), y("span", {
      role: "status",
      class: x(r.value)
    }, null, 2));
  }
}), ra = (e) => (br("data-v-e183bf9c"), e = e(), yr(), e), oa = ["id"], aa = { class: "text-xs" }, sa = {
  key: 0,
  class: "text-center py-1.5 px-3 leading-normal !border !border-gray-300"
}, la = { key: 0 }, ia = ["colspan"], ca = { class: "flex justify-center items-center min-h-[100px]" }, ua = /* @__PURE__ */ ra(() => /* @__PURE__ */ D("div", { class: "flex justify-center items-center min-h-[100px]" }, "No data", -1)), da = ["onClick"], fa = {
  key: 0,
  class: "text-center"
}, pa = { key: 1 }, ga = /* @__PURE__ */ F({
  __name: "Table",
  props: {
    id: {},
    fields: {},
    data: {},
    clickable: { type: Boolean },
    selectable: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean },
    stickyHeader: { type: Boolean },
    footer: { type: Boolean },
    hideHeader: { type: Boolean },
    tbodyTrClass: {},
    rowKey: { default: "" }
  },
  emits: ["rowClick", "rowsSelected"],
  setup(e, { emit: t }) {
    const n = e, r = ee($(["h-9", "px-3", "text-left"]), {
      variants: {
        clickable: {
          true: "cursor-pointer"
        },
        disabled: {
          true: "cursor-auto"
        }
      },
      defaultVariants: {}
    }), o = S(r(n));
    N(
      [() => n.clickable, () => n.disabled],
      () => {
        o.value = r(n);
      },
      { immediate: !0 }
    );
    const a = S(
      n.data.map((g) => ({ ...g, isSelected: !1 }))
    ), s = S(!1);
    function i() {
      const b = a.value.filter((m) => m.isSelected).map((m) => {
        const { isSelected: C, ...A } = m;
        return A;
      });
      t("rowsSelected", b);
    }
    N(
      [() => n.data],
      () => {
        const g = n.data.map((m) => ({ ...m, isSelected: !1 })), b = a.value.filter((m) => m.isSelected).length > 0;
        a.value = g, s.value = !1, b && i();
      },
      { immediate: !0, deep: !0 }
    );
    function l(g) {
      a.value.forEach((b) => {
        b.isSelected = g !== null;
      }), s.value = g !== null, i();
    }
    function c(g, b) {
      a.value[b].isSelected = g !== null, s.value = !a.value.some((m) => !m.isSelected), i();
    }
    function u(g) {
      n.clickable && !n.disabled && t("rowClick", g);
    }
    function d(g, b) {
      let m = "";
      return typeof g == "string" ? m = m.concat(" ", g) : Array.isArray(g) && g.every((C) => typeof C == "string") ? m = m.concat(" ", g.join(" ")) : typeof g == "function" && b && typeof g(b) == "string" ? m = m.concat(" ", g(b)) : console.warn(
        "Invalid class type:",
        typeof g,
        "Must be a string, an array of strings or a function returning a string"
      ), m;
    }
    function f(g) {
      return g.tdAttr && typeof g.tdAttr != "object" ? (console.warn("Invalid tdAttr type:", typeof g.tdAttr, "Must be an object"), {}) : { ...g.tdAttr };
    }
    function p({ item: g, field: b }) {
      let m = o.value;
      return b.tdClass && (m = m.concat(d(b == null ? void 0 : b.tdClass, g))), m;
    }
    function h(g) {
      return n.rowKey && typeof g[n.rowKey] < "u" ? `${g[n.rowKey]}` : "";
    }
    return (g, b) => (v(), y("div", {
      class: x(g.stickyHeader ? "" : "overflow-auto")
    }, [
      D("table", {
        id: g.id,
        class: "w-full table-auto bg-white"
      }, [
        g.hideHeader ? R("", !0) : (v(), y("thead", {
          key: 0,
          class: x(g.stickyHeader ? "sticky top-0 bg-white" : "")
        }, [
          D("tr", aa, [
            g.selectable ? (v(), y("th", sa, [
              _(g.$slots, "head-select-all", {}, () => [
                j(qe, {
                  id: `table-${g.id}-checkbox-all-row`,
                  disabled: g.loading || g.disabled,
                  checked: s.value,
                  value: g.data,
                  onChange: b[0] || (b[0] = (m) => l(m))
                }, null, 8, ["id", "disabled", "checked", "value"])
              ], !0)
            ])) : R("", !0),
            (v(!0), y(le, null, Z(g.fields, (m) => (v(), y("th", {
              key: m.key,
              class: "text-left py-1.5 px-3 leading-normal !border !border-gray-300"
            }, [
              _(g.$slots, `head-${m.key}`, { item: m }, () => [
                V(B(m.label), 1)
              ], !0)
            ]))), 128))
          ])
        ], 2)),
        D("tbody", null, [
          g.data.length === 0 ? (v(), y("tr", la, [
            D("td", {
              colspan: g.fields.length + (g.selectable ? 1 : 0)
            }, [
              g.loading ? _(g.$slots, "loading", { key: 0 }, () => [
                D("div", ca, [
                  j(Un, { variant: "primary" })
                ])
              ], !0) : g.data.length === 0 ? _(g.$slots, "no-data", { key: 1 }, () => [
                ua
              ], !0) : R("", !0)
            ], 8, ia)
          ])) : g.data.length > 0 ? (v(!0), y(le, { key: 1 }, Z(g.data, (m, C) => (v(), y("tr", {
            key: h(m) || C,
            class: x([
              "transition-colors",
              n.tbodyTrClass ? d(n.tbodyTrClass, m) : "",
              g.clickable ? "hover:bg-gray-50" : "",
              g.loading ? "pointer-events-none opacity-50" : ""
            ]),
            onClick: (A) => u(m)
          }, [
            g.selectable ? (v(), y("td", fa, [
              _(g.$slots, "body-select-row", {
                index: C,
                item: m
              }, () => [
                j(qe, {
                  id: `table-${g.id}-checkbox-row-${h(m) || C}}`,
                  disabled: g.loading || g.disabled,
                  checked: a.value[C].isSelected,
                  value: a.value[C],
                  onChange: (A) => c(A, C),
                  onClick: b[1] || (b[1] = lt(() => {
                  }, ["stop"]))
                }, null, 8, ["id", "disabled", "checked", "value", "onChange"])
              ], !0)
            ])) : R("", !0),
            (v(!0), y(le, null, Z(g.fields, (A) => (v(), y("td", Te({
              key: `${h(m) || C}-${A.key}`,
              class: p({ item: m, field: A })
            }, f(A)), [
              _(g.$slots, `body-${A.key}`, {
                index: C,
                item: m
              }, () => [
                V(B(m[A.key]), 1)
              ], !0)
            ], 16))), 128))
          ], 10, da))), 128)) : R("", !0)
        ]),
        g.footer ? (v(), y("tfoot", pa, [
          _(g.$slots, "footer", {}, () => [
            D("tr", null, [
              g.selectable ? (v(), y("th", {
                key: 0,
                class: x(`${o.value} w-9 text-center`)
              }, [
                j(qe, {
                  id: `table-${g.id}-checkbox-all-row`,
                  disabled: g.loading || g.disabled,
                  checked: s.value,
                  value: g.data,
                  onChange: b[2] || (b[2] = (m) => l(m))
                }, null, 8, ["id", "disabled", "checked", "value"])
              ], 2)) : R("", !0),
              (v(!0), y(le, null, Z(g.fields, (m) => (v(), y("th", {
                key: m.key,
                class: x(`${o.value} `)
              }, [
                _(g.$slots, `footer-${m.key}`, {}, () => [
                  V(B(m.label), 1)
                ], !0)
              ], 2))), 128))
            ])
          ], !0)
        ])) : R("", !0)
      ], 8, oa)
    ], 2));
  }
});
const Xn = /* @__PURE__ */ we(ga, [["__scopeId", "data-v-e183bf9c"]]), ha = [
  { text: "5", value: 5 },
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
], va = /* @__PURE__ */ F({
  __name: "Pagination",
  props: {
    limit: {},
    total: {},
    offset: {},
    disabled: { type: Boolean }
  },
  emits: ["updateOffset"],
  setup(e, { emit: t }) {
    const n = e, r = T(() => Math.ceil(n.total / n.limit)), o = T(() => Math.floor(n.offset / n.limit) + 1), a = T(() => r.value < 5 ? [...Array(r.value).keys()].map((c) => c + 1) : [1, 2].includes(o.value) ? [1, 2, 3, 4] : [r.value, r.value - 1].includes(o.value) ? [
      r.value - 3,
      r.value - 2,
      r.value - 1,
      r.value
    ] : [o.value - 1, o.value, o.value + 1]), s = (c) => {
      if (c === o.value)
        return;
      const u = (c - 1) * n.limit;
      t("updateOffset", u);
    };
    function i() {
      o.value !== 1 && s(o.value - 1);
    }
    function l() {
      o.value !== r.value && s(o.value + 1);
    }
    return (c, u) => c.limit < c.total ? (v(), q(Wn, {
      key: 0,
      class: "pagination flex justify-end",
      "data-test-pagination-group": ""
    }, {
      default: O(() => [
        j(se, {
          disabled: c.disabled || o.value === 1,
          variant: "outline-primary",
          size: "sm",
          "data-test-pagination-first": "",
          onClick: u[0] || (u[0] = (d) => s(1))
        }, {
          default: O(() => [
            V(" « ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        j(se, {
          disabled: c.disabled || o.value === 1,
          variant: "outline-primary",
          size: "sm",
          "data-test-pagination-previous": "",
          onClick: i
        }, {
          default: O(() => [
            V(" ‹ ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        a.value[0] > 1 ? (v(), q(se, {
          key: 0,
          class: "cursor-default",
          variant: "outline-primary",
          size: "sm",
          disabled: ""
        }, {
          default: O(() => [
            V(" … ")
          ]),
          _: 1
        })) : R("", !0),
        (v(!0), y(le, null, Z(a.value, (d) => (v(), q(se, {
          key: d,
          class: x({ selected: o.value === d }),
          disabled: c.disabled,
          size: "sm",
          "data-test-pagination-page": "",
          onClick: (f) => s(d)
        }, {
          default: O(() => [
            V(B(d), 1)
          ]),
          _: 2
        }, 1032, ["class", "disabled", "onClick"]))), 128)),
        a.value[a.value.length - 1] < r.value ? (v(), q(se, {
          key: 1,
          variant: "outline-primary",
          size: "sm",
          disabled: ""
        }, {
          default: O(() => [
            V(" … ")
          ]),
          _: 1
        })) : R("", !0),
        j(se, {
          class: "page-navigation",
          disabled: c.disabled || o.value === r.value,
          variant: "outline-primary",
          size: "sm",
          "data-test-pagination-next": "",
          onClick: l
        }, {
          default: O(() => [
            V(" › ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        j(se, {
          disabled: c.disabled || o.value === r.value,
          variant: "outline-primary",
          size: "sm",
          "data-test-pagination-last": "",
          onClick: u[1] || (u[1] = (d) => s(r.value))
        }, {
          default: O(() => [
            V(" » ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })) : R("", !0);
  }
});
const Qn = /* @__PURE__ */ we(va, [["__scopeId", "data-v-4cf2b84a"]]), ma = ["disabled"], ba = { class: "ml-2" }, ya = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15px",
  height: "15px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "none",
  transform: "scale(0.6,0.8)",
  class: "ml-2"
}, wa = ["opacity"], ka = ["opacity"], xa = /* @__PURE__ */ F({
  __name: "SortableButton",
  props: {
    isActive: { type: Boolean },
    isAscending: { type: Boolean },
    isSortable: { type: Boolean },
    fieldKey: {},
    fieldLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    return (n, r) => (v(), y("div", null, [
      n.isSortable ? (v(), y("button", {
        key: 0,
        class: "w-full flex justify-between items-center disabled:no-underline bg-transparent border-none",
        disabled: n.disabled,
        onClick: r[0] || (r[0] = (o) => t("click", n.fieldKey))
      }, [
        _(n.$slots, n.fieldKey, {}, () => [
          V(B(n.fieldLabel), 1)
        ]),
        D("div", ba, [
          (v(), y("svg", ya, [
            D("path", {
              fill: "currentColor",
              opacity: n.isActive && n.isAscending ? 1 : 0.3,
              d: "M51 1l25 23 24 22H1l25-22z"
            }, null, 8, wa),
            D("path", {
              fill: "currentColor",
              opacity: n.isActive && !n.isAscending ? 1 : 0.3,
              d: "M51 101l25-23 24-22H1l25 22z"
            }, null, 8, ka)
          ]))
        ])
      ], 8, ma)) : _(n.$slots, n.fieldKey, { key: 1 }, () => [
        V(B(n.fieldLabel), 1)
      ])
    ]));
  }
}), _a = { class: "flex flex-col gap-2" }, Ca = {
  key: 0,
  class: "flex justify-end"
}, Sa = /* @__PURE__ */ F({
  __name: "TablePaginated",
  props: {
    id: {},
    fields: {},
    data: {},
    ordering: {},
    total: {},
    limit: {},
    offset: {},
    hidePageLimitSelector: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean },
    clickable: { type: Boolean },
    selectable: { type: Boolean },
    footer: { type: Boolean },
    tbodyTrClass: {},
    rowKey: {}
  },
  emits: ["updateQuery", "rowClick", "rowsSelected"],
  setup(e, { emit: t }) {
    const n = e, r = T(() => n.ordering[0] === "-" ? n.ordering.substring(1) : n.ordering), o = T(() => n.ordering[0] !== "-");
    function a(l) {
      t("updateQuery", {
        limit: l,
        offset: 0,
        ordering: n.ordering
      });
    }
    function s(l) {
      let c;
      l === r.value ? c = o.value ? `-${l}` : l : c = l, t("updateQuery", {
        limit: n.limit,
        offset: 0,
        ordering: c
      });
    }
    function i(l) {
      t("updateQuery", {
        limit: n.limit,
        offset: l,
        ordering: n.ordering
      });
    }
    return (l, c) => (v(), y("div", _a, [
      l.hidePageLimitSelector ? R("", !0) : (v(), y("div", Ca, [
        D("div", null, [
          j(Hn, {
            id: `table-${l.id}-limit`,
            label: "Per Page:",
            disabled: l.loading || l.disabled,
            value: l.limit,
            options: k(ha),
            "data-test-pagination-page-limit-selector": "",
            onInput: a
          }, null, 8, ["id", "disabled", "value", "options"])
        ])
      ])),
      j(Xn, {
        id: l.id,
        clickable: l.clickable,
        selectable: l.selectable,
        fields: l.fields,
        data: l.data,
        loading: l.loading,
        disabled: l.disabled,
        footer: l.footer,
        "tbody-tr-class": l.tbodyTrClass,
        rowKey: l.rowKey,
        onRowClick: c[0] || (c[0] = (u) => l.$emit("rowClick", u)),
        onRowsSelected: c[1] || (c[1] = (u) => l.$emit("rowsSelected", u))
      }, wr({
        loading: O(() => [
          _(l.$slots, "loading")
        ]),
        "no-data": O(() => [
          _(l.$slots, "no-data")
        ]),
        footer: O(() => [
          _(l.$slots, "footer")
        ]),
        _: 2
      }, [
        Z(l.fields, (u) => ({
          name: `head-${u.key}`,
          fn: O(({ item: d }) => [
            u.sortable ? (v(), q(xa, {
              key: u.key,
              "data-test-table-header-sorting-button": "",
              "is-active": u.key === r.value,
              "is-ascending": o.value,
              "is-sortable": u.sortable,
              "field-key": u.key,
              "field-label": u.label,
              disabled: l.loading || l.disabled,
              onClick: (f) => s(u.key)
            }, {
              [u.key]: O(() => [
                _(l.$slots, `head-${u.key}`, { item: d }, () => [
                  V(B(u.label), 1)
                ])
              ]),
              _: 2
            }, 1032, ["is-active", "is-ascending", "is-sortable", "field-key", "field-label", "disabled", "onClick"])) : _(l.$slots, `head-${u.key}`, {
              key: 1,
              item: d
            }, () => [
              V(B(u.label), 1)
            ])
          ])
        })),
        Z(l.fields, (u) => ({
          name: `body-${u.key}`,
          fn: O(({ item: d }) => [
            _(l.$slots, `body-${u.key}`, { item: d }, () => [
              V(B(d[u.key]), 1)
            ])
          ])
        })),
        Z(l.fields, (u) => ({
          name: `footer-${u.key}`,
          fn: O(() => [
            _(l.$slots, `footer-${u.key}`, {}, () => [
              V(B(u.label), 1)
            ])
          ])
        }))
      ]), 1032, ["id", "clickable", "selectable", "fields", "data", "loading", "disabled", "footer", "tbody-tr-class", "rowKey"]),
      j(Qn, {
        disabled: l.loading || l.disabled,
        limit: l.limit,
        total: l.total,
        offset: l.offset,
        onUpdateOffset: i
      }, null, 8, ["disabled", "limit", "total", "offset"])
    ]));
  }
}), $a = /* @__PURE__ */ D("path", { d: "M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" }, null, -1), Ma = [
  $a
], wt = /* @__PURE__ */ F({
  __name: "CloseButton",
  props: {
    invert: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    return (n, r) => (v(), y("button", {
      "data-test-dialog-close-button": "",
      class: x(["justify-self-end", "rounded-full", "focus:outline-primary"]),
      onClick: r[0] || (r[0] = (o) => t("click", o))
    }, [
      (v(), y("svg", {
        width: "15px",
        height: "15px",
        viewBox: "0 0 24 24",
        class: x(
          n.invert ? ["fill-white", "hover:fill-gray-500"] : ["fill-gray-500", "hover:fill-current"]
        ),
        xmlns: "http://www.w3.org/2000/svg"
      }, Ma, 2))
    ]));
  }
}), Aa = ["id"], Oa = {
  class: /* @__PURE__ */ x(["text-xl"])
}, Da = /* @__PURE__ */ F({
  __name: "Dialog",
  props: {
    id: {},
    open: { type: Boolean },
    size: {},
    title: { default: "" },
    content: { default: "" },
    scrollable: { type: Boolean },
    okOnly: { type: Boolean },
    okTitle: { default: "Ok" },
    okDisabled: { type: Boolean },
    okVariant: { default: "primary" },
    cancelTitle: { default: "Cancel" },
    cancelDisabled: { type: Boolean },
    cancelVariant: { default: "light" },
    bodyClass: {},
    dialogClass: { default: "" },
    contentClass: { default: "" },
    headerClass: { default: "" },
    footerClass: { default: "" },
    hideFooter: { type: Boolean, default: !1 },
    hideHeader: { type: Boolean, default: !1 },
    disablePadding: { type: Boolean, default: !1 }
  },
  emits: ["dialogClose", "ok", "shown", "hidden"],
  setup(e, { emit: t }) {
    const n = e, r = ee(
      "p-0 m-0 backdrop:bg-gray-400 backdrop:bg-opacity-50 absolute bottom-0 -translate-x-1/2 left-1/2 top-[150px]",
      {
        variants: {
          size: {
            sm: "text-base w-full max-w-[18.75rem]  rounded",
            md: "text-base w-full max-w-[31.25rem] rounded",
            lg: "text-base w-full max-w-[50rem] rounded",
            xl: "text-base w-full max-w-[71.25rem] rounded",
            "2xl": "text-base w-full max-w-[100rem] rounded"
          }
        },
        defaultVariants: {
          size: "md"
        }
      }
    ), o = S(null), a = S(G(r(n))), s = S(!1), i = (f) => {
      s.value = f.currentTarget === f.target;
    }, l = (f) => {
      s.value && f.currentTarget === f.target && t("dialogClose", f), s.value = !1;
    }, c = function(f) {
      t("ok", f);
    }, u = function(f) {
      t("dialogClose", f);
    }, d = function(f) {
      f.code === "Escape" && t("dialogClose", f);
    };
    return N(
      [() => n.size],
      () => {
        a.value = G(
          r({
            ...n
          })
        );
      },
      { immediate: !0 }
    ), N(
      [() => n.open],
      () => {
        var f, p;
        n.open === !0 ? ((f = o.value) == null || f.showModal(), t("shown")) : ((p = o.value) == null || p.close(), t("hidden"));
      },
      { immediate: !1 }
    ), (f, p) => (v(), y("dialog", {
      id: n.id,
      key: `${n.id}_dialog`,
      ref_key: "dialogElement",
      ref: o,
      class: x([
        "p-0",
        "backdrop:bg-gray-400",
        "backdrop:bg-opacity-50",
        a.value,
        n.dialogClass
      ]),
      onKeydown: d,
      onMousedown: i,
      onMouseup: l
    }, [
      D("div", {
        class: x(["pointer-events-auto", n.contentClass])
      }, [
        f.hideHeader ? R("", !0) : (v(), y("header", {
          key: 0,
          class: x([
            "flex",
            "items-center",
            "!p-4",
            "justify-between",
            "border-b",
            "border-gray-300",
            n.headerClass
          ])
        }, [
          _(f.$slots, "modal-header", {}, () => [
            _(f.$slots, "modal-title", {}, () => [
              D("h1", Oa, B(n.title), 1)
            ]),
            j(wt, {
              class: x(["justify-self-end", "rounded-full", "focus:outline-primary"]),
              onClick: p[0] || (p[0] = (h) => f.$emit("dialogClose", h))
            })
          ])
        ], 2)),
        n.open ? (v(), y("div", {
          key: 1,
          class: x([
            { "p-4": !n.disablePadding },
            { "overflow-y-auto max-h-[650px]": n.scrollable },
            n.bodyClass
          ])
        }, [
          _(f.$slots, "default")
        ], 2)) : R("", !0),
        f.hideFooter ? R("", !0) : (v(), y("div", {
          key: 2,
          class: x([
            "flex",
            "flex-wrap",
            "items-center",
            "justify-end",
            "gap-4",
            "!px-4",
            "!py-2",
            "border-t",
            "border-gray-300",
            n.footerClass
          ])
        }, [
          _(f.$slots, "modal-footer", {}, () => [
            n.okOnly ? R("", !0) : (v(), q(se, {
              key: 0,
              class: "justify-self-start",
              "data-test-dialog-cancel-button": "",
              disabled: n.cancelDisabled,
              variant: n.cancelVariant,
              onClick: u
            }, {
              default: O(() => [
                _(f.$slots, "cancel-title", {}, () => [
                  V(B(n.cancelTitle), 1)
                ])
              ]),
              _: 3
            }, 8, ["disabled", "variant"])),
            j(se, {
              class: "justify-self-end",
              "data-test-dialog-ok-button": "",
              variant: n.okVariant,
              disabled: n.okDisabled,
              onClick: c
            }, {
              default: O(() => [
                _(f.$slots, "ok-title", {}, () => [
                  V(B(n.okTitle), 1)
                ])
              ]),
              _: 3
            }, 8, ["variant", "disabled"])
          ])
        ], 2))
      ], 2)
    ], 42, Aa));
  }
}), Ta = {
  key: 0,
  class: "flex justify-between items-center"
}, Ea = {
  class: "text-lg font-medium",
  "data-test-toast-title": ""
}, za = { "data-test-toast-message": "" }, Jn = /* @__PURE__ */ F({
  __name: "Toast",
  props: {
    variant: {},
    dismissible: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = ee(
      $([
        "flex flex-col gap-1",
        "p-2",
        "rounded-lg",
        "w-[400px]",
        "shadow-xl",
        "border-l-8",
        "bg-white",
        "text-dark"
      ]),
      {
        variants: {
          variant: {
            primary: $(["border-primary"]),
            secondary: $(["border-secondary"]),
            tertiary: $(["border-tertiary"]),
            danger: $(["border-danger"]),
            warning: $(["border-warning"]),
            success: $(["border-success"]),
            info: $(["border-info"])
          }
        },
        defaultVariants: {
          variant: "primary"
        }
      }
    ), o = Sn(), a = T(() => {
      var l, c, u;
      return o.title ? ((u = (c = (l = o.title()[0]) == null ? void 0 : l.children) == null ? void 0 : c.toString()) == null ? void 0 : u.trim().length) > 0 : !1;
    });
    function s() {
      t("close");
    }
    const i = S(
      G(
        r({
          ...n
        })
      )
    );
    return (l, c) => (v(), y("div", {
      class: x(i.value),
      role: "dialog",
      "data-test-toast": ""
    }, [
      a.value || l.dismissible ? (v(), y("div", Ta, [
        D("div", Ea, [
          _(l.$slots, "title")
        ]),
        l.dismissible ? (v(), q(wt, {
          key: 0,
          "data-test-toast-close-button": "",
          onClick: s
        })) : R("", !0)
      ])) : R("", !0),
      D("p", za, [
        _(l.$slots, "default")
      ])
    ], 2));
  }
}), Fa = Symbol("Toaster"), Ra = { class: "min-h-full h-full relative" }, Ia = ["innerHTML"], Pa = /* @__PURE__ */ F({
  __name: "Toaster",
  setup(e) {
    const t = S([]);
    function n(a) {
      t.value = t.value.filter((s) => s.id !== a);
    }
    function r(a) {
      var l, c;
      const s = crypto.randomUUID(), i = {
        id: s,
        title: ((l = a.title) == null ? void 0 : l.toString()) || "",
        message: ((c = a.message) == null ? void 0 : c.toString()) || "",
        variant: a.variant,
        dismissible: a.dismissible
      };
      t.value.push(i), setTimeout(() => {
        n(s);
      }, a.timeout || 3e3);
    }
    mt(Fa, { addToast: r });
    const o = S(
      G($(["fixed right-[20px] top-[20px] z-[9999]", "flex flex-col gap-2"]))
    );
    return (a, s) => (v(), y("div", Ra, [
      j(kr, {
        tag: "span",
        class: x(o.value)
      }, {
        default: O(() => [
          (v(!0), y(le, null, Z(t.value, (i) => (v(), q(Jn, {
            key: i.id,
            variant: i.variant,
            dismissible: i.dismissible,
            onClose: (l) => n(i.id)
          }, {
            title: O(() => [
              V(B(i.title), 1)
            ]),
            default: O(() => [
              D("p", {
                innerHTML: i.message
              }, null, 8, Ia)
            ]),
            _: 2
          }, 1032, ["variant", "dismissible", "onClose"]))), 128))
        ]),
        _: 1
      }, 8, ["class"]),
      _(a.$slots, "default", {}, void 0, !0)
    ]));
  }
});
const Va = /* @__PURE__ */ we(Pa, [["__scopeId", "data-v-f8559ae3"]]), Be = Math.min, Me = Math.max, ft = Math.round, st = Math.floor, Ce = (e) => ({
  x: e,
  y: e
}), Ba = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Na = {
  start: "end",
  end: "start"
};
function Et(e, t, n) {
  return Me(e, Be(t, n));
}
function et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Oe(e) {
  return e.split("-")[0];
}
function tt(e) {
  return e.split("-")[1];
}
function Zn(e) {
  return e === "x" ? "y" : "x";
}
function Bt(e) {
  return e === "y" ? "height" : "width";
}
function kt(e) {
  return ["top", "bottom"].includes(Oe(e)) ? "y" : "x";
}
function Nt(e) {
  return Zn(kt(e));
}
function Ga(e, t, n) {
  n === void 0 && (n = !1);
  const r = tt(e), o = Nt(e), a = Bt(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = pt(s)), [s, pt(s)];
}
function La(e) {
  const t = pt(e);
  return [zt(e), t, zt(t)];
}
function zt(e) {
  return e.replace(/start|end/g, (t) => Na[t]);
}
function ja(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : s;
    default:
      return [];
  }
}
function Ya(e, t, n, r) {
  const o = tt(e);
  let a = ja(Oe(e), n === "start", r);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map(zt)))), a;
}
function pt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ba[t]);
}
function Wa(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function er(e) {
  return typeof e != "number" ? Wa(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function sn(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = kt(t), s = Nt(t), i = Bt(s), l = Oe(t), c = a === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[i] / 2 - o[i] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (tt(t)) {
    case "start":
      p[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const Ha = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = a.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = sn(c, r, l), f = r, p = {}, h = 0;
  for (let g = 0; g < i.length; g++) {
    const {
      name: b,
      fn: m
    } = i[g], {
      x: C,
      y: A,
      data: W,
      reset: L
    } = await m({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = C ?? u, d = A ?? d, p = {
      ...p,
      [b]: {
        ...p[b],
        ...W
      }
    }, L && h <= 50) {
      h++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (c = L.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : L.rects), {
        x: u,
        y: d
      } = sn(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function tr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: s,
    elements: i,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = et(t, e), h = er(p), b = i[f ? d === "floating" ? "reference" : "floating" : d], m = gt(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(b))) == null || n ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), C = d === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), W = await (a.isElement == null ? void 0 : a.isElement(A)) ? await (a.getScale == null ? void 0 : a.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = gt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: C,
    offsetParent: A,
    strategy: l
  }) : C);
  return {
    top: (m.top - L.top + h.top) / W.y,
    bottom: (L.bottom - m.bottom + h.bottom) / W.y,
    left: (m.left - L.left + h.left) / W.x,
    right: (L.right - m.right + h.right) / W.x
  };
}
const Ka = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = et(e, t) || {};
    if (c == null)
      return {};
    const d = er(u), f = {
      x: n,
      y: r
    }, p = Nt(o), h = Bt(p), g = await s.getDimensions(c), b = p === "y", m = b ? "top" : "left", C = b ? "bottom" : "right", A = b ? "clientHeight" : "clientWidth", W = a.reference[h] + a.reference[p] - f[p] - a.floating[h], L = f[p] - a.reference[p], Q = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let E = Q ? Q[A] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(Q))) && (E = i.floating[A] || a.floating[h]);
    const te = W / 2 - L / 2, I = E / 2 - g[h] / 2 - 1, H = Be(d[m], I), P = Be(d[C], I), M = H, ne = E - g[h] - P, U = E / 2 - g[h] / 2 + te, ie = Et(M, U, ne), ae = !l.arrow && tt(o) != null && U != ie && a.reference[h] / 2 - (U < M ? H : P) - g[h] / 2 < 0, pe = ae ? U < M ? U - M : U - ne : 0;
    return {
      [p]: f[p] + pe,
      data: {
        [p]: ie,
        centerOffset: U - ie - pe,
        ...ae && {
          alignmentOffset: pe
        }
      },
      reset: ae
    };
  }
}), qa = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...b
      } = et(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const m = Oe(o), C = Oe(i) === i, A = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), W = f || (C || !g ? [pt(i)] : La(i));
      !f && h !== "none" && W.push(...Ya(i, g, h, A));
      const L = [i, ...W], Q = await tr(t, b), E = [];
      let te = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && E.push(Q[m]), d) {
        const M = Ga(o, s, A);
        E.push(Q[M[0]], Q[M[1]]);
      }
      if (te = [...te, {
        placement: o,
        overflows: E
      }], !E.every((M) => M <= 0)) {
        var I, H;
        const M = (((I = a.flip) == null ? void 0 : I.index) || 0) + 1, ne = L[M];
        if (ne)
          return {
            data: {
              index: M,
              overflows: te
            },
            reset: {
              placement: ne
            }
          };
        let U = (H = te.filter((ie) => ie.overflows[0] <= 0).sort((ie, ae) => ie.overflows[1] - ae.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!U)
          switch (p) {
            case "bestFit": {
              var P;
              const ie = (P = te.map((ae) => [ae.placement, ae.overflows.filter((pe) => pe > 0).reduce((pe, Ge) => pe + Ge, 0)]).sort((ae, pe) => ae[1] - pe[1])[0]) == null ? void 0 : P[0];
              ie && (U = ie);
              break;
            }
            case "initialPlacement":
              U = i;
              break;
          }
        if (o !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
async function Ua(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Oe(n), i = tt(n), l = kt(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = a && l ? -1 : 1, d = et(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return i && typeof h == "number" && (p = i === "end" ? h * -1 : h), l ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const Xa = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await Ua(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, Qa = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: s = !1,
        limiter: i = {
          fn: (b) => {
            let {
              x: m,
              y: C
            } = b;
            return {
              x: m,
              y: C
            };
          }
        },
        ...l
      } = et(e, t), c = {
        x: n,
        y: r
      }, u = await tr(t, l), d = kt(Oe(o)), f = Zn(d);
      let p = c[f], h = c[d];
      if (a) {
        const b = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", C = p + u[b], A = p - u[m];
        p = Et(C, p, A);
      }
      if (s) {
        const b = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", C = h + u[b], A = h - u[m];
        h = Et(C, h, A);
      }
      const g = i.fn({
        ...t,
        [f]: p,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
};
function Se(e) {
  return nr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ke(e) {
  var t;
  return (t = (nr(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function nr(e) {
  return e instanceof Node || e instanceof fe(e).Node;
}
function be(e) {
  return e instanceof Element || e instanceof fe(e).Element;
}
function ve(e) {
  return e instanceof HTMLElement || e instanceof fe(e).HTMLElement;
}
function ln(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof fe(e).ShadowRoot;
}
function nt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = ge(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Ja(e) {
  return ["table", "td", "th"].includes(Se(e));
}
function Gt(e) {
  const t = Lt(), n = ge(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Za(e) {
  let t = Ne(e);
  for (; ve(t) && !xt(t); ) {
    if (Gt(t))
      return t;
    t = Ne(t);
  }
  return null;
}
function Lt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function xt(e) {
  return ["html", "body", "#document"].includes(Se(e));
}
function ge(e) {
  return fe(e).getComputedStyle(e);
}
function _t(e) {
  return be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Ne(e) {
  if (Se(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ln(e) && e.host || // Fallback.
    ke(e)
  );
  return ln(t) ? t.host : t;
}
function rr(e) {
  const t = Ne(e);
  return xt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ve(t) && nt(t) ? t : rr(t);
}
function Qe(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = rr(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = fe(o);
  return a ? t.concat(s, s.visualViewport || [], nt(o) ? o : [], s.frameElement && n ? Qe(s.frameElement) : []) : t.concat(o, Qe(o, [], n));
}
function or(e) {
  const t = ge(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = ve(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, i = ft(n) !== a || ft(r) !== s;
  return i && (n = a, r = s), {
    width: n,
    height: r,
    $: i
  };
}
function jt(e) {
  return be(e) ? e : e.contextElement;
}
function Ve(e) {
  const t = jt(e);
  if (!ve(t))
    return Ce(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = or(t);
  let s = (a ? ft(n.width) : n.width) / r, i = (a ? ft(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const es = /* @__PURE__ */ Ce(0);
function ar(e) {
  const t = fe(e);
  return !Lt() || !t.visualViewport ? es : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ts(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== fe(e) ? !1 : t;
}
function De(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = jt(e);
  let s = Ce(1);
  t && (r ? be(r) && (s = Ve(r)) : s = Ve(e));
  const i = ts(a, n, r) ? ar(a) : Ce(0);
  let l = (o.left + i.x) / s.x, c = (o.top + i.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (a) {
    const f = fe(a), p = r && be(r) ? fe(r) : r;
    let h = f.frameElement;
    for (; h && r && p !== f; ) {
      const g = Ve(h), b = h.getBoundingClientRect(), m = ge(h), C = b.left + (h.clientLeft + parseFloat(m.paddingLeft)) * g.x, A = b.top + (h.clientTop + parseFloat(m.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += C, c += A, h = fe(h).frameElement;
    }
  }
  return gt({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function ns(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = ve(n), a = ke(n);
  if (n === a)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = Ce(1);
  const l = Ce(0);
  if ((o || !o && r !== "fixed") && ((Se(n) !== "body" || nt(a)) && (s = _t(n)), ve(n))) {
    const c = De(n);
    i = Ve(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: t.width * i.x,
    height: t.height * i.y,
    x: t.x * i.x - s.scrollLeft * i.x + l.x,
    y: t.y * i.y - s.scrollTop * i.y + l.y
  };
}
function rs(e) {
  return Array.from(e.getClientRects());
}
function sr(e) {
  return De(ke(e)).left + _t(e).scrollLeft;
}
function os(e) {
  const t = ke(e), n = _t(e), r = e.ownerDocument.body, o = Me(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Me(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + sr(e);
  const i = -n.scrollTop;
  return ge(r).direction === "rtl" && (s += Me(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: i
  };
}
function as(e, t) {
  const n = fe(e), r = ke(e), o = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, i = 0, l = 0;
  if (o) {
    a = o.width, s = o.height;
    const c = Lt();
    (!c || c && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: i,
    y: l
  };
}
function ss(e, t) {
  const n = De(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = ve(e) ? Ve(e) : Ce(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: s,
    height: i,
    x: l,
    y: c
  };
}
function cn(e, t, n) {
  let r;
  if (t === "viewport")
    r = as(e, n);
  else if (t === "document")
    r = os(ke(e));
  else if (be(t))
    r = ss(t, n);
  else {
    const o = ar(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return gt(r);
}
function lr(e, t) {
  const n = Ne(e);
  return n === t || !be(n) || xt(n) ? !1 : ge(n).position === "fixed" || lr(n, t);
}
function ls(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Qe(e, [], !1).filter((i) => be(i) && Se(i) !== "body"), o = null;
  const a = ge(e).position === "fixed";
  let s = a ? Ne(e) : e;
  for (; be(s) && !xt(s); ) {
    const i = ge(s), l = Gt(s);
    !l && i.position === "fixed" && (o = null), (a ? !l && !o : !l && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || nt(s) && !l && lr(e, s)) ? r = r.filter((u) => u !== s) : o = i, s = Ne(s);
  }
  return t.set(e, r), r;
}
function is(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? ls(t, this._c) : [].concat(n), r], i = s[0], l = s.reduce((c, u) => {
    const d = cn(t, u, o);
    return c.top = Me(d.top, c.top), c.right = Be(d.right, c.right), c.bottom = Be(d.bottom, c.bottom), c.left = Me(d.left, c.left), c;
  }, cn(t, i, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function cs(e) {
  return or(e);
}
function us(e, t, n) {
  const r = ve(t), o = ke(t), a = n === "fixed", s = De(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ce(0);
  if (r || !r && !a)
    if ((Se(t) !== "body" || nt(o)) && (i = _t(t)), r) {
      const c = De(t, !0, a, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = sr(o));
  return {
    x: s.left + i.scrollLeft - l.x,
    y: s.top + i.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function un(e, t) {
  return !ve(e) || ge(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function ir(e, t) {
  const n = fe(e);
  if (!ve(e))
    return n;
  let r = un(e, t);
  for (; r && Ja(r) && ge(r).position === "static"; )
    r = un(r, t);
  return r && (Se(r) === "html" || Se(r) === "body" && ge(r).position === "static" && !Gt(r)) ? n : r || Za(e) || n;
}
const ds = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || ir, a = this.getDimensions;
  return {
    reference: us(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function fs(e) {
  return ge(e).direction === "rtl";
}
const ps = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ns,
  getDocumentElement: ke,
  getClippingRect: is,
  getOffsetParent: ir,
  getElementRects: ds,
  getClientRects: rs,
  getDimensions: cs,
  getScale: Ve,
  isElement: be,
  isRTL: fs
};
function gs(e, t) {
  let n = null, r;
  const o = ke(e);
  function a() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (i || t(), !d || !f)
      return;
    const p = st(u), h = st(o.clientWidth - (c + d)), g = st(o.clientHeight - (u + f)), b = st(c), C = {
      rootMargin: -p + "px " + -h + "px " + -g + "px " + -b + "px",
      threshold: Me(0, Be(1, l)) || 1
    };
    let A = !0;
    function W(L) {
      const Q = L[0].intersectionRatio;
      if (Q !== l) {
        if (!A)
          return s();
        Q ? s(!1, Q) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(W, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(W, C);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function hs(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = jt(e), u = o || a ? [...c ? Qe(c) : [], ...Qe(t)] : [];
  u.forEach((m) => {
    o && m.addEventListener("scroll", n, {
      passive: !0
    }), a && m.addEventListener("resize", n);
  });
  const d = c && i ? gs(c, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((m) => {
    let [C] = m;
    C && C.target === c && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let h, g = l ? De(e) : null;
  l && b();
  function b() {
    const m = De(e);
    g && (m.x !== g.x || m.y !== g.y || m.width !== g.width || m.height !== g.height) && n(), g = m, h = requestAnimationFrame(b);
  }
  return n(), () => {
    u.forEach((m) => {
      o && m.removeEventListener("scroll", n), a && m.removeEventListener("resize", n);
    }), d && d(), p && p.disconnect(), p = null, l && cancelAnimationFrame(h);
  };
}
const vs = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ps,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return Ha(e, t, {
    ...o,
    platform: a
  });
};
function Ft(e) {
  var t;
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
function ms(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = Ft(k(e.element));
      return n == null ? {} : Ka({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function cr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dn(e, t) {
  const n = cr(e);
  return Math.round(t * n) / n;
}
function bs(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, o = T(() => {
    var E;
    return (E = k(n.open)) != null ? E : !0;
  }), a = T(() => k(n.middleware)), s = T(() => {
    var E;
    return (E = k(n.placement)) != null ? E : "bottom";
  }), i = T(() => {
    var E;
    return (E = k(n.strategy)) != null ? E : "absolute";
  }), l = T(() => {
    var E;
    return (E = k(n.transform)) != null ? E : !0;
  }), c = T(() => Ft(e.value)), u = T(() => Ft(t.value)), d = S(0), f = S(0), p = S(i.value), h = S(s.value), g = xr({}), b = S(!1), m = T(() => {
    const E = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return E;
    const te = dn(u.value, d.value), I = dn(u.value, f.value);
    return l.value ? {
      ...E,
      transform: "translate(" + te + "px, " + I + "px)",
      ...cr(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: te + "px",
      top: I + "px"
    };
  });
  let C;
  function A() {
    c.value == null || u.value == null || vs(c.value, u.value, {
      middleware: a.value,
      placement: s.value,
      strategy: i.value
    }).then((E) => {
      d.value = E.x, f.value = E.y, p.value = E.strategy, h.value = E.placement, g.value = E.middlewareData, b.value = !0;
    });
  }
  function W() {
    typeof C == "function" && (C(), C = void 0);
  }
  function L() {
    if (W(), r === void 0) {
      A();
      return;
    }
    if (c.value != null && u.value != null) {
      C = r(c.value, u.value, A);
      return;
    }
  }
  function Q() {
    o.value || (b.value = !1);
  }
  return N([a, s, i], A, {
    flush: "sync"
  }), N([c, u], L, {
    flush: "sync"
  }), N(o, Q, {
    flush: "sync"
  }), _n() && Cn(W), {
    x: ze(d),
    y: ze(f),
    strategy: ze(p),
    placement: ze(h),
    middlewareData: ze(g),
    isPositioned: ze(b),
    floatingStyles: m,
    update: A
  };
}
const Yt = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "FloatingUI",
  props: {
    _class: {},
    as: { default: "div" },
    for: {},
    role: { default: "tooltip" },
    placement: {},
    arrow: { type: Boolean },
    arrowStyles: { default: "" },
    middleware: {},
    offset: { default: 10 }
  },
  setup(e) {
    const t = e, n = S(t.for), r = S(null), o = S(null);
    if (typeof n.value == "string") {
      const d = document.querySelector(n.value);
      d || console.error(
        `❗Element with selector "${n.value}" not found, please use a valid css selector for the :for on the component`
      ), n.value = d;
    }
    const a = [qa(), Xa(t.offset), ...t.middleware ?? []];
    t.arrow && a.push(
      ms({
        element: o,
        padding: 5
      })
    );
    const { placement: s, floatingStyles: i, middlewareData: l } = bs(
      n,
      r,
      {
        placement: t.placement,
        middleware: a,
        whileElementsMounted: hs
      }
    ), c = T(() => {
      var h;
      if (!((h = l.value) != null && h.arrow))
        return {};
      const { x: d, y: f } = l.value.arrow ?? {}, p = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[s.value.split("-")[0]];
      return {
        top: f != null ? `${f}px` : "",
        left: d != null ? `${d}px` : "",
        [p]: "-4px"
      };
    }), u = T(
      () => G("absolute transform rotate-45 bg-white w-[8px] h-[8px]", t.arrowStyles)
    );
    return $n(() => {
      r.value && r.value.removeAttribute("class");
    }), (d, f) => (v(), q(_r(d.as), {
      ref_key: "floating",
      ref: r,
      role: d.role,
      style: qt({
        ...k(i),
        zIndex: 50
      })
    }, {
      default: O(() => [
        _(d.$slots, "default", { arrowPosition: c.value }),
        d.arrow ? (v(), y("div", {
          key: 0,
          ref_key: "arrowElement",
          ref: o,
          class: x(u.value),
          style: qt(c.value),
          "data-test-arrow": ""
        }, null, 6)) : R("", !0)
      ]),
      _: 3
    }, 8, ["role", "style"]));
  }
}), ys = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    for: {},
    _class: {},
    variant: {},
    as: { default: "div" },
    placement: { default: "top" },
    trigger: { default: "hover" },
    show: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ee(
      $([
        "px-1.5 py-1 text-xs rounded-sm max-w-[200px] break-words text-center whitespace-break-spaces"
      ]),
      {
        variants: {
          variant: {
            primary: "bg-dark text-light",
            secondary: `bg-secondary text-${me("secondary") ? "light" : "dark"}`,
            success: "bg-success text-white",
            danger: "bg-danger text-white"
          }
        },
        defaultVariants: {
          variant: "primary"
        }
      }
    ), r = ee($(["rounded-br-sm rounded-tl-sm"]), {
      variants: {
        variant: {
          primary: "bg-dark",
          secondary: "bg-secondary",
          success: "bg-success",
          danger: "bg-danger"
        }
      },
      defaultVariants: {
        variant: "primary"
      }
    }), o = S(!1), a = S(null), s = S(t.show ?? !1);
    N(
      () => t.show,
      () => {
        s.value = t.show ?? !1;
      }
    );
    const i = S(
      G(
        n({
          ...t
        }),
        t._class
      )
    ), l = S(
      G(
        r({
          ...t
        }),
        t._class
      )
    );
    function c(u) {
      (Array.isArray(t.trigger) ? t.trigger : [t.trigger]).forEach((f) => {
        switch (f) {
          case "hover":
            u.addEventListener("mouseenter", () => {
              s.value = !0;
            }), u.addEventListener("mouseleave", () => {
              s.value = !1;
            });
            break;
          case "click":
            u.addEventListener("click", () => {
              s.value = !s.value;
            });
            break;
          case "focus":
            u.addEventListener("focus", () => {
              s.value = !0;
            }), u.addEventListener("blur", () => {
              s.value = !1;
            });
            break;
          default:
            s.value = t.show;
        }
      });
    }
    return $n(() => {
      o.value = !0;
      try {
        typeof t.for == "string" ? a.value = document.querySelector(t.for) : a.value = t.for;
      } catch {
        console.warn(
          "Tooltip failed to attach, probably because a test is not setup correctly. Check https://v1.test-utils.vuejs.org/api/options.html#attachto"
        );
      }
      a.value && c(a.value);
    }), (u, d) => o.value && s.value ? (v(), q(Yt, {
      key: 0,
      as: t.as,
      for: t.for,
      placement: u.placement,
      arrow: "",
      "arrow-styles": l.value,
      middleware: [k(Qa)()]
    }, {
      default: O(() => [
        D("div", {
          class: x(i.value)
        }, [
          _(u.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["as", "for", "placement", "arrow-styles", "middleware"])) : R("", !0);
  }
}), ws = {}, ks = {
  class: "inline-block w-3 h-3",
  xmlns: "http://www.w3.org/2000/svg",
  height: "4",
  viewBox: "0 0 32 32",
  width: "5",
  fill: "currentColor"
}, xs = /* @__PURE__ */ D("path", { d: "M4 8 H28 L16 26 z" }, null, -1), _s = [
  xs
];
function Cs(e, t) {
  return v(), y("svg", ks, _s);
}
const fn = /* @__PURE__ */ we(ws, [["render", Cs]]), Wt = Symbol("Dropdown"), Ss = /* @__PURE__ */ D("span", { class: "sr-only" }, "Toggle dropdown", -1), $s = {
  class: "bg-white border rounded min-w-[150px]",
  "data-test-dropdown-menu": ""
}, Ms = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "Dropdown",
  props: {
    text: {},
    split: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    right: { type: Boolean, default: !1 },
    disabled: { type: Boolean },
    toggleClass: {},
    variant: { default: "secondary" },
    size: {},
    block: { type: Boolean },
    debounce: {}
  },
  setup(e) {
    const t = e, n = ye(), r = S(null), o = S(null), a = S(null), s = S(!1), i = S(null), l = T(() => ({
      "is-active": s.value,
      "!bg-gray-600 hover:!bg-gray-500 focus:ring-gray-600 fill-white": t.variant === null,
      [t.toggleClass ?? ""]: !0
    }));
    function c(p, h = !1) {
      if (h) {
        if (t.split) {
          typeof n.onClick == "function" && n.onClick(p);
          return;
        }
        s.value = !s.value;
        return;
      }
      s.value = !s.value;
    }
    function u() {
      s.value = !1;
    }
    Nr(r, u);
    const { focused: d } = Lr(o);
    N(d, (p) => {
      p || (s.value = !1);
    });
    const { stop: f } = Br(o, () => {
      if (o.value) {
        Array.from(o.value.children).filter((g) => {
          const b = g.getAttribute("tabindex");
          return b !== null && parseInt(b, 10) >= 0;
        }).forEach((g) => {
          g.addEventListener("click", () => {
            s.value = !1;
          }), g.addEventListener("keydown", (b) => {
            b.key === "Enter" && (s.value = !1);
          });
        });
        const { onKeyDown: h } = Yn(o, "vertical");
        i.value = h, f();
      }
    });
    return mt(Wt, { hide: u }), (p, h) => (v(), y("div", {
      ref_key: "anchorRef",
      ref: r,
      class: x([t.block ? "flex" : "inline-flex", k(n).class])
    }, [
      j(se, {
        ref_key: "buttonRef",
        ref: a,
        block: t.block,
        size: t.size,
        variant: t.variant,
        disabled: p.disabled,
        class: x({
          "!rounded-r-none": p.split,
          ...l.value
        }),
        onClick: h[0] || (h[0] = (g) => c(g, !0))
      }, {
        default: O(() => [
          D("div", {
            class: x(["flex items-center", t.block ? "justify-between" : "justify-start gap-1"])
          }, [
            _(p.$slots, "button-content", {}, () => [
              V(B(p.text), 1)
            ]),
            p.split ? R("", !0) : (v(), q(fn, { key: 0 }))
          ], 2)
        ]),
        _: 3
      }, 8, ["block", "size", "variant", "disabled", "class"]),
      p.split ? (v(), q(se, {
        key: 0,
        size: t.size,
        variant: t.variant,
        disabled: p.disabled,
        class: x(["!rounded-l-none !border-l-0", {
          ...l.value
        }]),
        onClick: h[1] || (h[1] = (g) => c(g))
      }, {
        default: O(() => [
          Ss,
          j(fn)
        ]),
        _: 1
      }, 8, ["size", "variant", "disabled", "class"])) : R("", !0),
      r.value ? Je((v(), q(Yt, {
        key: 1,
        for: r.value,
        placement: p.right ? "bottom-end" : p.placement,
        offset: 5,
        class: "z-50",
        role: "menu"
      }, {
        default: O(() => [
          D("div", $s, [
            D("ul", {
              ref_key: "listRef",
              ref: o,
              class: "py-1",
              role: "group",
              tabindex: "-1",
              onKeydown: h[2] || (h[2] = (g) => i.value && i.value(g))
            }, [
              _(p.$slots, "default")
            ], 544)
          ])
        ]),
        _: 3
      }, 8, ["for", "placement"])), [
        [Cr, s.value]
      ]) : R("", !0)
    ], 2));
  }
}), As = ["onKeydown"], Os = /* @__PURE__ */ F({
  __name: "DropdownItem",
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = ye(), n = vt(Wt);
    function r(o) {
      typeof t.click == "function" && t.click(o), n == null || n.hide();
    }
    return (o, a) => (v(), y("li", {
      role: "presentation",
      tabindex: "0",
      "data-test-dropdown-item": "",
      class: x([
        k($)([
          "w-full px-4 py-1 cursor-pointer text-left dark:text-black",
          o.active ? "hover:bg-primary" : "hover:bg-gray-200",
          "focus:bg-gray-200 focus:outline-none",
          "disabled:opacity-50 disabled:pointer-events-none",
          k(me)("primary") ? "active:text-white" : "active:text-black"
        ]),
        { "bg-primary": o.active }
      ]),
      onClick: r,
      onKeydown: it(r, ["enter"])
    }, [
      _(o.$slots, "default")
    ], 42, As));
  }
}), Ds = ["onKeydown"], Ts = /* @__PURE__ */ F({
  inheritAttrs: !1,
  __name: "DropdownItemButton",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = ye(), n = vt(Wt);
    function r() {
      typeof t.click == "function" && t.click(), n == null || n.hide();
    }
    return (o, a) => (v(), y("li", {
      role: "button",
      class: x({ "!cursor-not-allowed": k(t).disabled !== void 0 })
    }, [
      D("button", Te({ tabindex: "0" }, k(t), {
        class: [
          k($)([
            "w-full px-4 py-1 cursor-pointer text-left dark:text-black",
            o.active ? "hover:bg-primary" : "hover:bg-gray-200",
            "focus:bg-gray-200 focus:outline-none",
            "disabled:opacity-50 disabled:pointer-events-none",
            k(me)("primary") ? "active:text-white" : "active:text-black"
          ]),
          { "bg-primary": o.active }
        ],
        onClick: r,
        onKeydown: it(r, ["enter"])
      }), [
        _(o.$slots, "default")
      ], 16, Ds)
    ], 2));
  }
}), Es = {}, zs = {
  role: "presentation",
  class: "my-2"
}, Fs = /* @__PURE__ */ D("hr", null, null, -1), Rs = [
  Fs
];
function Is(e, t) {
  return v(), y("li", zs, Rs);
}
const Ps = /* @__PURE__ */ we(Es, [["render", Is]]), Vs = { class: "flex gap-1 items-center" }, Bs = ["value", "checked", "aria-invalid", "aria-checked"], ur = /* @__PURE__ */ F({
  inheritAttrs: !1,
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  __name: "Radio",
  props: {
    modelValue: {},
    value: {},
    _class: {},
    state: {},
    checked: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, r = ee(
      $([
        "checked:after:empty-content checked:after:aspect-square checked:after:h-1/3 checked:after:block",
        "checked:after:rounded-full checked:after:bg-white",
        "grid place-items-center",
        "bg-white cursor-pointer appearance-none h-4 w-4 rounded-full border border-gray-400",
        "checked:bg-primary checked:!border-primary",
        "focus:outline-none focus:ring-2 focus:ring-opacity-50 focus:ring-primary focus:border-primary",
        "disabled:opacity-50 disabled:cursor-not-allowed"
      ]),
      {
        variants: {
          state: {
            true: $([Ae.true, "checked:bg-success checked:border-success"]),
            false: $([Ae.false, "checked:bg-danger checked:border-danger"])
          }
        },
        defaultVariants: {
          state: null
        }
      }
    ), o = ye(), a = T(() => n.modelValue === void 0 ? n.checked : n.modelValue === n.value), s = T({
      get() {
        return n.modelValue === void 0 && n.checked ? n.value : n.modelValue;
      },
      set(l) {
        t("update:modelValue", l ?? null), t("change", l ?? null);
      }
    }), i = S(G(r(n)));
    return N(
      [() => n.state],
      () => {
        i.value = G(r(n));
      },
      { immediate: !0 }
    ), (l, c) => (v(), y("div", Vs, [
      Je(D("input", Te(k(o), {
        "onUpdate:modelValue": c[0] || (c[0] = (u) => s.value = u),
        type: "radio",
        value: l.value,
        checked: a.value,
        class: [i.value, l._class, { "bg-gray-300": k(o).disabled }],
        "aria-invalid": l.state === !1 && l.state !== null ? !0 : void 0,
        "aria-checked": l.checked ? "true" : "false"
      }), null, 16, Bs), [
        [Sr, s.value]
      ]),
      j(yt, {
        for: k(o).id,
        class: x([
          "inline-block !mb-0 text-base font-inherit",
          { "text-gray-400": l.$attrs.disabled },
          { "cursor-not-allowed": l.$attrs.disabled }
        ])
      }, {
        default: O(() => [
          _(l.$slots, "default")
        ]),
        _: 3
      }, 8, ["for", "class"])
    ]));
  }
}), Ns = { class: "gap-2 flex flex-wrap" }, Gs = /* @__PURE__ */ F({
  __name: "RadioGroup",
  props: {
    modelValue: {},
    value: {},
    options: {},
    disabled: { type: Boolean },
    name: {}
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    function n(r) {
      t("update:modelValue", r), t("change", r);
    }
    return (r, o) => (v(), y("div", Ns, [
      (v(!0), y(le, null, Z(r.options, (a, s) => (v(), q(ur, {
        id: a.id ?? `radio-${r.name}-${s}`,
        key: a.value,
        value: a.value,
        name: r.name,
        disabled: a.disabled || r.disabled,
        checked: r.modelValue === a.value || r.value === a.value,
        onChange: n
      }, {
        default: O(() => [
          V(B(a.text), 1)
        ]),
        _: 2
      }, 1032, ["id", "value", "name", "disabled", "checked"]))), 128))
    ]));
  }
}), Ls = {};
function js(e, t) {
  return v(), y("div", {
    class: x([
      "flex",
      "[&_button:first-child]:!rounded-l-none",
      "[&_button:not(:last-of-type)]:!rounded-r-none",
      "[&_button:last-child]:!rounded-l-none",
      "[&>div:first-child]:!rounded-l-none",
      "[&>div:not(:last-of-type)]:!rounded-r-none",
      "[&>div:last-child]:!rounded-l-none"
    ])
  }, [
    _(e.$slots, "default")
  ], 2);
}
const Ys = /* @__PURE__ */ we(Ls, [["render", js]]), Ws = {};
function Hs(e, t) {
  return v(), y("div", {
    class: x([
      "flex",
      "[&_button:first-child]:!rounded-r-none",
      "[&_button:not(:last-of-type)]:!rounded-l-none",
      "[&_button:last-child]:!rounded-r-none",
      "[&>div:first-child]:!rounded-r-none",
      "[&>div:not(:last-child)]:!rounded-l-none",
      "[&>div:last-child]:!rounded-r-none"
    ])
  }, [
    _(e.$slots, "default")
  ], 2);
}
const Ks = /* @__PURE__ */ we(Ws, [["render", Hs]]), pn = "bg-gray-200 text-dark px-3 grid place-items-center rounded border !border-gray-300 whitespace-nowrap", dr = /* @__PURE__ */ F({
  __name: "InputGroup",
  props: {
    size: {},
    prepend: { default: "" },
    append: { default: "" }
  },
  setup(e) {
    const t = e, n = ee(
      $([
        Vt,
        "!p-0 !border-none !flex !items-stretch isolate",
        "[&_button:focus]:relative [&_button:focus]:z-10",
        "[&_input:focus]:relative [&_input:focus]:z-10"
      ]),
      {
        variants: {
          size: {
            sm: "text-sm rounded-sm",
            md: "text-base",
            lg: "text-lg"
          }
        },
        defaultVariants: {
          size: "md"
        }
      }
    );
    mt(bt, t.size || "md");
    const r = S(G(n(t))), o = Sn();
    return N(
      [() => t.size],
      () => {
        r.value = G(n(t));
      },
      { immediate: !0 }
    ), (a, s) => (v(), y("div", {
      class: x(r.value)
    }, [
      j(Ks, null, {
        default: O(() => [
          _(a.$slots, "prepend", {}, () => [
            a.prepend ? (v(), y("div", {
              key: 0,
              class: x(`${pn} !border-r-0 !rounded-r-none`)
            }, B(a.prepend), 3)) : R("", !0)
          ])
        ]),
        _: 3
      }),
      D("div", {
        class: x([
          "flex w-full",
          {
            "[&>input:first-child]:!rounded-l-none": a.prepend,
            "[&>input:last-child]:!rounded-r-none": a.append,
            "[&>input]:!rounded-r-none": k(o) && k(o).append,
            "[&>input]:!rounded-l-none": k(o) && k(o).prepend,
            "[&>input:first-child]:!rounded-r-none !border-r-0": k(o) && k(o).default && k(o).default().length > 1,
            "[&>input:not(:last-child)]:!rounded-none": k(o) && k(o).default && k(o).default().length > 2,
            "[&>input:last-child]:!rounded-l-none": k(o) && k(o).default && k(o).default().length > 1
          }
        ])
      }, [
        _(a.$slots, "default")
      ], 2),
      j(Ys, null, {
        default: O(() => [
          _(a.$slots, "append", {}, () => [
            a.append ? (v(), y("div", {
              key: 0,
              class: x(`${pn} !border-l-0 !rounded-l-none`)
            }, B(a.append), 3)) : R("", !0)
          ])
        ]),
        _: 3
      })
    ], 2));
  }
}), qs = (e, t) => {
  if (e.length !== t.length)
    return !1;
  let n = !0;
  for (let r = 0; n && r < e.length; r++)
    n = Ht(e[r], t[r]);
  return n;
}, gn = (e) => e instanceof Date, hn = (e) => Array.isArray(e), vn = (e) => e !== null && typeof e == "object", mn = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Ht = (e, t) => {
  if (e === t)
    return !0;
  let n = gn(e), r = gn(t);
  if (n || r)
    return n && r ? e.getTime() === t.getTime() : !1;
  if (n = hn(e), r = hn(t), n || r)
    return n && r ? qs(e, t) : !1;
  if (n = vn(e), r = vn(t), n || r) {
    if (!n || !r)
      return !1;
    const o = Object.keys(e).length, a = Object.keys(t).length;
    if (o !== a)
      return !1;
    for (const s in e) {
      const i = mn(e, s), l = mn(t, s);
      if (i && !l || !i && l || !Ht(e[s], t[s]))
        return !1;
    }
  }
  return String(e) === String(t);
}, Us = { class: "gap-1 flex flex-wrap" }, Xs = /* @__PURE__ */ F({
  __name: "CheckboxGroup",
  props: {
    options: {},
    value: {},
    modelValue: {},
    name: {},
    legend: {},
    _switch: { type: Boolean }
  },
  emits: ["input", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = T(() => {
      const a = {};
      return (n.value || n.modelValue || []).forEach((i, l) => {
        const c = n.options.find((u) => Ht(u.value, i));
        c && (a[c.key] = { index: l, value: i });
      }), a;
    });
    function o(a, s) {
      const i = r.value[s], l = [...n.value || n.modelValue || []];
      a === null && i && l.splice(i.index, 1), a && !i && l.push(a), t("input", l), t("update:modelValue", l);
    }
    return (a, s) => (v(), y("div", Us, [
      (v(!0), y(le, null, Z(a.options, (i) => (v(), q(qe, {
        id: `${a.name}-${i.key}`,
        key: i.key,
        value: i.value,
        label: i.text,
        disabled: i.disabled || !1,
        checked: r.value[i.key],
        switch: a._switch,
        onChange: (l) => o(l, i.key)
      }, null, 8, ["id", "value", "label", "disabled", "checked", "switch", "onChange"]))), 128))
    ]));
  }
}), Qs = /* @__PURE__ */ F({
  __name: "Nav",
  props: {
    tabs: { type: Boolean },
    pill: { type: Boolean },
    vertical: { type: Boolean },
    align: { default: "start" }
  },
  setup(e) {
    const t = e;
    return (n, r) => (v(), y("nav", {
      class: x([
        "group",
        "flex",
        `justify-${t.align}`,
        "[&>.active]:text-primary",
        { "flex-col": t.vertical },
        { "border-b border-gray-300": t.tabs },
        { "[&>*]:-mb-[2px] [&>*]:border [&>*]:border-transparent": t.tabs },
        {
          "[&>.active]:bg-white [&>.active]:text-primary [&>.active]:border [&>.active]:border-gray-300 [&>.active]:border-b-white [&>.active]:rounded-t": t.tabs
        },
        {
          "[&>*:hover]:border [&>*:hover]:border-gray-300 [&>*:hover]:border-b-white [&>*:hover]:rounded-t isolate": t.tabs
        }
      ])
    }, [
      _(n.$slots, "default")
    ], 2));
  }
}), Js = ["aria-current"], Zs = /* @__PURE__ */ F({
  __name: "NavItem",
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e;
    return (r, o) => (v(), y("div", {
      class: x([
        "hover:text-primary/70",
        { "pointer-events-none opacity-20": n.disabled },
        { active: n.active }
      ])
    }, [
      D("a", {
        class: x([
          "inline-block",
          "px-4 py-2",
          "cursor-pointer",
          n.active ? "text-primary" : "text-dark"
        ]),
        "aria-current": n.active ? "page" : void 0,
        onClick: o[0] || (o[0] = (a) => t("click"))
      }, [
        _(r.$slots, "default")
      ], 10, Js)
    ], 2));
  }
}), el = ["onDragover", "onDragleave", "onDrop"], tl = ["accept"], nl = /* @__PURE__ */ F({
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  __name: "FileUpload",
  props: {
    modelValue: {},
    accept: { default: "*" },
    browseText: { default: "Browse" },
    classInput: {},
    classButton: {},
    buttonVariant: { default: "light" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: "Choose a file or drop it here..." },
    dropPlaceholder: { default: "Drop file here..." }
  },
  emits: ["input", "update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = S(null), a = S(!1), s = S(null), i = T(() => a.value ? r.dropPlaceholder : s.value ? s.value.name : r.placeholder);
    function l() {
      if (r.disabled)
        return;
      const h = o.value;
      h && h.click();
    }
    function c() {
      r.disabled || (a.value = !0);
    }
    function u() {
      r.disabled || (a.value = !1);
    }
    function d(h) {
      const g = h.target, { files: b } = g;
      b && b.length > 0 && (s.value = b[0], n("update:modelValue", s.value), n("input", s.value));
    }
    function f(h) {
      var b;
      if (r.disabled)
        return;
      const g = (b = h.dataTransfer) == null ? void 0 : b.files;
      g && g.length > 0 && (s.value = g[0], n("update:modelValue", s.value), n("input", s.value));
    }
    function p() {
      a.value = !1, s.value = null;
    }
    return N(
      () => r.modelValue,
      (h) => {
        s.value = h;
      },
      { immediate: !0 }
    ), N(
      () => s.value,
      () => {
        a.value = !1;
      }
    ), t({
      openFilePicker: l,
      file: s,
      reset: p,
      dragleave: u,
      dragover: c,
      onDrop: f,
      beingDragged: a,
      placeholderText: i
    }), (h, g) => (v(), y("div", {
      class: "relative",
      onDragover: lt(c, ["prevent"]),
      onDragleave: lt(u, ["prevent"]),
      onDrop: lt(f, ["stop", "prevent"])
    }, [
      D("input", {
        ref_key: "uploadInput",
        ref: o,
        class: "hidden",
        type: "file",
        accept: h.accept,
        onChange: d
      }, null, 40, tl),
      j(dr, { class: "relative" }, {
        append: O(() => [
          j(se, {
            disabled: h.disabled,
            variant: h.buttonVariant,
            class: x(h.classButton),
            onClick: l
          }, {
            default: O(() => [
              V(B(r.browseText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant", "class"])
        ]),
        default: O(() => [
          j(qn, {
            class: x(h.classInput),
            disabled: h.disabled,
            type: "text",
            readonly: "",
            placeholder: i.value,
            onClick: l
          }, null, 8, ["class", "disabled", "placeholder"])
        ]),
        _: 1
      })
    ], 40, el));
  }
}), rl = /* @__PURE__ */ F({
  __name: "Alert",
  props: {
    show: { type: Boolean, default: !0 },
    dismissible: { type: Boolean },
    variant: {}
  },
  setup(e) {
    const t = e, n = ee($(["relative", "border rounded px-4 py-3 mb-3"]), {
      variants: {
        variant: {
          primary: "bg-lightCyan-200 !border-lightCyan-300 text-cyan-900",
          info: "bg-blue-200 !border-blue-300 text-blue-900",
          warning: "bg-yellow-200 !border-yellow-300 text-yellow-900",
          danger: "bg-red-200 !border-red-300 text-red-900",
          success: "bg-green-200 !border-green-300 text-green-900"
        }
      },
      defaultVariants: {
        variant: "primary"
      }
    }), r = S(G(n(t))), o = S(t.show);
    return N(
      () => t.variant,
      () => {
        r.value = G(n(t));
      }
    ), (a, s) => o.value ? (v(), y("div", {
      key: 0,
      class: x(r.value)
    }, [
      a.dismissible ? (v(), q(wt, {
        key: 0,
        class: "absolute top-2 right-2",
        onClick: s[0] || (s[0] = (i) => o.value = !1)
      })) : R("", !0),
      _(a.$slots, "default")
    ], 2)) : R("", !0);
  }
});
function Rt(e) {
  "@babel/helpers - typeof";
  return Rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rt(e);
}
function Ct(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function oe(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function re(e) {
  oe(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Rt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function ol(e, t) {
  oe(2, arguments);
  var n = re(e), r = Ct(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function bn(e, t) {
  oe(2, arguments);
  var n = re(e), r = Ct(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var s = a.getDate();
  return o >= s ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), o), n);
}
function al(e) {
  oe(1, arguments);
  var t = re(e), n = t.getDay();
  return n === 0 || n === 6;
}
var sl = {};
function fr() {
  return sl;
}
function yn(e, t) {
  var n, r, o, a, s, i, l, c;
  oe(1, arguments);
  var u = fr(), d = Ct((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = re(e), p = f.getDay(), h = (p < d ? 7 : 0) + p - d;
  return f.setDate(f.getDate() - h), f.setHours(0, 0, 0, 0), f;
}
function wn(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function ht(e) {
  oe(1, arguments);
  var t = re(e);
  return t.setHours(0, 0, 0, 0), t;
}
var ll = 864e5;
function il(e, t) {
  oe(2, arguments);
  var n = ht(e), r = ht(t), o = n.getTime() - wn(n), a = r.getTime() - wn(r);
  return Math.round((o - a) / ll);
}
function cl(e, t) {
  oe(2, arguments);
  var n = ht(e), r = ht(t);
  return n.getTime() === r.getTime();
}
function ul(e, t) {
  var n;
  oe(1, arguments);
  var r = e || {}, o = re(r.start), a = re(r.end), s = a.getTime();
  if (!(o.getTime() <= s))
    throw new RangeError("Invalid interval");
  var i = [], l = o;
  l.setHours(0, 0, 0, 0);
  var c = Number((n = t == null ? void 0 : t.step) !== null && n !== void 0 ? n : 1);
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= s; )
    i.push(re(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return i;
}
function dl(e) {
  oe(1, arguments);
  var t = re(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function fl(e, t) {
  var n, r, o, a, s, i, l, c;
  oe(1, arguments);
  var u = fr(), d = Ct((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = re(e), p = f.getDay(), h = (p < d ? -7 : 0) + 6 - (p - d);
  return f.setDate(f.getDate() + h), f.setHours(23, 59, 59, 999), f;
}
function pl(e) {
  oe(1, arguments);
  var t = re(e), n = t.getDate();
  return n;
}
function gl(e) {
  oe(1, arguments);
  var t = re(e), n = il(t, dl(t)), r = n + 1;
  return r;
}
function hl(e) {
  oe(1, arguments);
  var t = re(e), n = t.getMonth();
  return n;
}
function kn(e) {
  return oe(1, arguments), re(e).getFullYear();
}
function vl(e, t) {
  oe(2, arguments);
  var n = re(e), r = re(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function ml(e, t, n) {
  return {
    date: t,
    dayOfWeek: n(t, "dd"),
    dayOfYear: gl(t),
    dayOfMonth: pl(t),
    isToday: cl(/* @__PURE__ */ new Date(), t),
    isSameMonth: vl(t, e),
    isWeekend: al(t)
  };
}
function Fe(e, { options: t }, n) {
  let r = yn(new Date(kn(e), hl(e)));
  const o = Array.from({ length: t.numOfWeeks || 0 }).map((s, i) => {
    const l = Array.from({ length: t.numOfDays || 0 }).map((c, u) => {
      const d = ml(e, r, n);
      return r = ol(r, 1), { dayIndex: u, weekIndex: i, ...d };
    });
    return t.rtl ? l.reverse() : l;
  }), a = ul({
    start: yn(r),
    end: fl(r)
  }).map((s) => n(s, "ddd"));
  return {
    startDate: e,
    month: n(e, "MMMM"),
    year: kn(e),
    weeks: o,
    days: a
  };
}
function pr(e, t) {
  const n = {
    M: e.getMonth() + 1,
    MM: String(e.getMonth() + 1).padStart(2, "0"),
    MMM: e.toLocaleString("en", { month: "short" }),
    MMMM: e.toLocaleString("en", { month: "long" }),
    D: e.getDate(),
    DD: String(e.getDate()).padStart(2, "0"),
    ddd: e.toLocaleString("en", { weekday: "short" }),
    dddd: e.toLocaleString("en", { weekday: "long" }),
    YY: String(e.getFullYear()).slice(-2),
    YYYY: e.getFullYear(),
    H: e.getHours(),
    HH: String(e.getHours()).padStart(2, "0"),
    m: e.getMinutes(),
    mm: String(e.getMinutes()).padStart(2, "0"),
    s: e.getSeconds(),
    ss: String(e.getSeconds()).padStart(2, "0")
  };
  return t.replace(/(\w+)/g, (r) => {
    const o = n[r];
    return String(typeof o == "function" ? o(e) : o ?? r);
  });
}
const xn = {
  startDate: null,
  month: null,
  days: [],
  weeks: [],
  years: [],
  months: [],
  options: {
    formatter: pr,
    numOfWeeks: 6,
    numOfDays: 7,
    rtl: !1
  }
};
function bl(e, t) {
  const n = S(t.formatter || pr);
  function r(c, u) {
    var d, f;
    switch (u.type) {
      case "SET_OPTIONS":
        return {
          ...c,
          options: { ...c.options, ...u.options }
        };
      case "SET_DATE":
        return { ...c, ...Fe(u.date, c, n.value) };
      case "SET_YEAR":
        return {
          ...c,
          ...Fe(
            new Date(Number(u.year), (d = c.startDate) == null ? void 0 : d.getMonth()),
            c,
            n.value
          )
        };
      case "SET_MONTH":
        return {
          ...c,
          ...Fe(
            new Date((f = c.startDate) == null ? void 0 : f.getFullYear(), u.month),
            c,
            n.value
          )
        };
      case "GET_NEXT_MONTH":
        return {
          ...c,
          ...Fe(bn(c.startDate, 1), c, n.value)
        };
      case "GET_PREV_MONTH":
        return {
          ...c,
          ...Fe(bn(c.startDate, -1), c, n.value)
        };
      case "GET_NEXT_YEAR":
        return {
          ...c,
          years: c.years.map((p) => String(Number(p) + 8))
        };
      case "GET_PREV_YEAR":
        return {
          ...c,
          years: c.years.map((p) => String(Number(p) - 8))
        };
      default:
        return c;
    }
  }
  function o(c) {
    const u = {
      ...xn,
      options: { ...xn.options, ...t }
    }, d = [];
    for (let f = 0; f < 12; f++) {
      const p = new Date(c.getFullYear(), f);
      d.push(n.value(p, "MMMM"));
    }
    return {
      ...u,
      ...Fe(c, u, n.value),
      months: d
    };
  }
  const a = S(o(e || /* @__PURE__ */ new Date())), s = (c) => {
    a.value = r(a.value, c);
  }, i = T(() => a.value.startDate);
  function l(c) {
    const u = [];
    for (let f = -7; f <= 7 + 1; f++) {
      const p = (new Date(c).getFullYear() + f).toString();
      u.push(p);
    }
    a.value.years = u;
  }
  return N(
    i,
    (c) => {
      s({ type: "SET_DATE", date: c }), l(c);
    },
    { immediate: !0 }
  ), {
    state: $r(a),
    actions: {
      setDate: (c) => s({ type: "SET_DATE", date: c }),
      setYear: (c) => s({ type: "SET_YEAR", year: c }),
      setMonth: (c) => s({ type: "SET_MONTH", month: c }),
      getNextMonth: () => s({
        type: "GET_NEXT_MONTH"
        /* GET_NEXT_MONTH */
      }),
      getPrevMonth: () => s({
        type: "GET_PREV_MONTH"
        /* GET_PREV_MONTH */
      }),
      getNextYear: () => s({
        type: "GET_NEXT_YEAR"
        /* GET_NEXT_YEAR */
      }),
      getPrevYear: () => s({
        type: "GET_PREV_YEAR"
        /* GET_PREV_YEAR */
      }),
      resetYears: (c) => l(c)
    }
  };
}
function yl(e, t) {
  function n(r) {
    var d;
    if (!e.value)
      return;
    const o = r.key.replace("Arrow", "").toLowerCase(), a = e.value.querySelectorAll(t.selector || "div");
    if (!a.length)
      return;
    const s = Array.from(a).findIndex(
      (f) => f === document.activeElement
    );
    if (s === -1)
      return;
    const i = a.length, l = t.columns || t.elements[0].length, c = {
      left: s - 1,
      right: s + 1,
      up: s - l,
      down: s + l
    }, u = {
      left: s % l !== 0,
      right: c.right % l !== 0,
      up: c.up >= 0,
      down: c.down < i
    };
    if (!u[o]) {
      (d = t.edgeCallback) == null || d.call(t, o);
      return;
    }
    o in c && u[o] && a[c[o]].focus();
  }
  return { onKeyDown: n };
}
const wl = /* @__PURE__ */ F({
  __name: "CurrentDateNotification",
  props: {
    selected: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (v(), y("div", {
      class: x([
        "h-1 aspect-square rounded-full",
        "absolute bottom-0.5 left-1/2 -translate-x-1/2",
        t.selected ? "bg-white" : "bg-primary"
      ])
    }, null, 2));
  }
}), kl = {
  type: "button",
  class: /* @__PURE__ */ x([
    "relative",
    "aspect-square flex justify-center items-center rounded",
    "ring-2 ring-offset-transparent ring-primary ring-opacity-0",
    "focus:outline-none focus:ring-opacity-50",
    "transition-colors",
    "hover:bg-gray-100"
  ])
}, $t = /* @__PURE__ */ F({
  __name: "CalendarButton",
  props: {
    showCurrentDateNotification: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (v(), y("button", kl, [
      t.showCurrentDateNotification ? (v(), q(wl, {
        key: 0,
        selected: t.selected
      }, null, 8, ["selected"])) : R("", !0),
      D("span", null, [
        _(t.$slots, "default")
      ])
    ]));
  }
}), xl = {
  class: /* @__PURE__ */ x(["relative", "border border-gray-300 rounded bg-white", "p-2 w-72 h-auto"])
}, _l = { class: "flex gap-2 items-center justify-between mb-2" }, Cl = { class: "flex gap-2 items-center" }, Sl = {
  key: 0,
  class: "grid grid-flow-col auto-cols-fr gap-1 mb-1"
}, $l = {
  key: 0,
  class: "space-y-2"
}, Ml = {
  key: 1,
  class: "space-y-2"
}, Al = { class: "grid grid-cols-4 gap-2" }, Ol = {
  key: 2,
  class: "space-y-2"
}, Dl = { class: "grid grid-cols-3 gap-2" }, Tl = /* @__PURE__ */ F({
  __name: "Calendar",
  props: {
    value: {},
    disabled: { type: Boolean },
    numOfWeeks: {},
    numOfDays: {},
    rtl: { type: Boolean },
    formatter: { type: Function }
  },
  emits: ["input"],
  setup(e, { emit: t }) {
    const n = e, r = Mr(n.value || null), o = S(null), a = S(!1), s = S(!1);
    function i() {
      a.value = !a.value, s.value = !1, a.value || u.resetYears(c.value.startDate);
    }
    function l() {
      s.value = !s.value, a.value = !1;
    }
    const { state: c, actions: u } = bl(r.value || /* @__PURE__ */ new Date(), {
      formatter: n.formatter
    });
    async function d(I) {
      var M;
      if (I === "up" || I === "down")
        return;
      I === "left" ? u.getPrevMonth() : u.getNextMonth(), await Ut();
      const H = (M = o.value) == null ? void 0 : M.querySelectorAll("button");
      if (!H || !H.length)
        return;
      const P = I === "left" ? H.length - 1 : 0;
      H[P].focus();
    }
    function f(I) {
      I === "up" || I === "down" || (I === "left" ? u.getPrevYear() : u.getNextYear(), Ut(() => {
        var M;
        const H = (M = o.value) == null ? void 0 : M.querySelectorAll("button");
        if (!H || !H.length)
          return;
        const P = I === "left" ? H.length - 1 : 0;
        H[P].focus();
      }));
    }
    const p = T(() => a.value ? c.value.years : s.value ? c.value.months : c.value.weeks), h = T(() => {
      if (a.value)
        return f;
      if (!s.value)
        return d;
    }), g = T(() => {
      if (s.value)
        return 3;
      if (a.value)
        return 4;
    }), b = Ar({
      selector: "button",
      elements: p,
      edgeCallback: h,
      columns: g
    }), { onKeyDown: m } = yl(o, b);
    function C(I) {
      r.value = I, t("input", I);
    }
    function A(I) {
      var H;
      return ((H = r.value) == null ? void 0 : H.toDateString()) === I.toDateString();
    }
    function W(I) {
      u.setYear(I), i();
    }
    function L(I) {
      u.setMonth(I), l();
    }
    function Q() {
      a.value ? u.getPrevYear() : u.getPrevMonth();
    }
    function E() {
      a.value ? u.getNextYear() : u.getNextMonth();
    }
    const te = [
      "text-sm flex gap-1 items-center rounded-sm",
      "hover:text-gray-500 transition-colors",
      "ring-2 ring-primary ring-opacity-0",
      "focus:outline-none focus:ring-opacity-50"
    ];
    return N(
      () => n.value,
      () => {
        u.setDate(n.value || /* @__PURE__ */ new Date()), r.value = n.value || null;
      }
    ), (I, H) => (v(), y("div", xl, [
      D("div", _l, [
        j(se, {
          type: "button",
          size: "sm",
          variant: "outline-white",
          onClick: Q
        }, {
          default: O(() => [
            V("<")
          ]),
          _: 1
        }),
        D("div", Cl, [
          D("button", {
            type: "button",
            class: x([...te, "font-bold"]),
            onClick: l
          }, B(k(c).month), 3),
          D("button", {
            type: "button",
            class: x(te),
            onClick: i
          }, [
            D("span", null, B(k(c).year), 1)
          ])
        ]),
        j(se, {
          type: "button",
          size: "sm",
          variant: "outline-white",
          onClick: E
        }, {
          default: O(() => [
            V(">")
          ]),
          _: 1
        })
      ]),
      !a.value && !s.value ? (v(), y("div", Sl, [
        (v(!0), y(le, null, Z(k(c).days, (P) => (v(), y("div", {
          key: P,
          class: "text-xs text-center text-gray-500"
        }, B(P), 1))), 128))
      ])) : R("", !0),
      D("div", {
        ref_key: "container",
        ref: o
      }, [
        !a.value && !s.value ? (v(), y("div", $l, [
          (v(!0), y(le, null, Z(k(c).weeks, (P, M) => (v(), y("div", {
            key: M,
            class: "grid grid-cols-7 gap-2 text-center"
          }, [
            (v(!0), y(le, null, Z(P, (ne) => (v(), q($t, {
              key: ne.dayOfMonth,
              selected: A(ne.date),
              "show-current-date-notification": ne.isToday,
              "data-test-day-button": "",
              class: x([
                ne.isSameMonth ? "text-black" : "text-gray-400",
                {
                  "!bg-primary !text-white hover:!bg-primary/80": A(ne.date)
                }
              ]),
              onClick: (U) => C(ne.date),
              onKeydown: k(m)
            }, {
              default: O(() => [
                V(B(ne.dayOfMonth), 1)
              ]),
              _: 2
            }, 1032, ["selected", "show-current-date-notification", "class", "onClick", "onKeydown"]))), 128))
          ]))), 128))
        ])) : R("", !0),
        a.value ? (v(), y("div", Ml, [
          D("div", Al, [
            (v(!0), y(le, null, Z(k(c).years, (P) => (v(), q($t, {
              key: P,
              selected: P === k(c).year.toString(),
              "show-current-date-notification": P === (/* @__PURE__ */ new Date()).getFullYear().toString(),
              "data-test-year-button": "",
              class: x({
                "!bg-primary !text-white hover:!bg-primary/80": P === k(c).year.toString()
              }),
              onClick: (M) => W(Number(P)),
              onKeydown: [
                k(m),
                it(i, ["escape"])
              ]
            }, {
              default: O(() => [
                V(B(P), 1)
              ]),
              _: 2
            }, 1032, ["selected", "show-current-date-notification", "class", "onClick", "onKeydown"]))), 128))
          ])
        ])) : R("", !0),
        s.value ? (v(), y("div", Ol, [
          D("div", Dl, [
            (v(!0), y(le, null, Z(k(c).months, (P) => (v(), q($t, {
              key: P,
              "data-test-month-button": "",
              selected: P === k(c).month.toString(),
              "show-current-date-notification": k(c).months.indexOf(P) === (/* @__PURE__ */ new Date()).getMonth() && k(c).year === (/* @__PURE__ */ new Date()).getFullYear(),
              class: x({
                "!bg-primary !text-white hover:!bg-primary/80": P === k(c).month.toString()
              }),
              onClick: (M) => L(k(c).months.indexOf(P)),
              onKeydown: [
                k(m),
                it(l, ["escape"])
              ]
            }, {
              default: O(() => [
                V(B(P), 1)
              ]),
              _: 2
            }, 1032, ["selected", "show-current-date-notification", "class", "onClick", "onKeydown"]))), 128))
          ])
        ])) : R("", !0)
      ], 512)
    ]));
  }
}), zl = {
  install: (e) => {
    e.component("GButton", se), e.component("GButtonGroup", Wn), e.component("GBadge", Jo), e.component("GSelect", Hn), e.component("GLabel", yt), e.component("GForm", Ho), e.component("GFormFeedback", Kn), e.component("GFormGroup", Uo), e.component("GInput", qn), e.component("GTextArea", ea), e.component("GTable", Xn), e.component("GTablePaginated", Sa), e.component("GToast", Jn), e.component("GToaster", Va), e.component("GTooltip", ys), e.component("GDialog", Da), e.component("GDropdown", Ms), e.component("GDropdownDivider", Ps), e.component("GDropdownItem", Os), e.component("GDropdownItemButton", Ts), e.component("GRadio", ur), e.component("GRadioGroup", Gs), e.component("GInputGroup", dr), e.component("GCheckbox", qe), e.component("GCheckboxGroup", Xs), e.component("GSpinner", Un), e.component("GNav", Qs), e.component("GNavItem", Zs), e.component("GFileUpload", nl), e.component("GAlert", rl), e.component("GCloseButton", wt), e.component("GPagination", Qn), e.component("GFloatingUI", Yt), e.component("GCalendar", Tl);
  }
};
export {
  rl as Alert,
  Jo as Badge,
  se as Button,
  Wn as ButtonGroup,
  Tl as Calendar,
  qe as Checkbox,
  Xs as CheckboxGroup,
  wt as CloseButton,
  Da as Dialog,
  Ms as Dropdown,
  Ps as DropdownDivider,
  Os as DropdownItem,
  Ts as DropdownItemButton,
  nl as FileUpload,
  Yt as FloatingUI,
  Ho as Form,
  Kn as FormFeedback,
  Uo as FormGroup,
  qn as Input,
  dr as InputGroup,
  yt as Label,
  Qs as Nav,
  Zs as NavItem,
  Qn as Pagination,
  ur as Radio,
  Gs as RadioGroup,
  Hn as Select,
  Un as Spinner,
  Xn as Table,
  Sa as TablePaginated,
  ea as TextArea,
  Jn as Toast,
  Va as Toaster,
  ys as Tooltip,
  zl as default,
  Fa as toasterKey,
  bl as useCalendar,
  yl as useGridFocus,
  Yn as useRovingFocus
};
